export default{
    "种茶":"种茶",
    "采茶":"采茶",
    "制茶":"制茶",
    "销茶":"销茶",
    "品茶":"品茶",
    "忆茶":"忆茶",

    // 聊天
    "在这里可以向我提问关于茶的专业知识":"在这里可以向我提问关于茶的专业知识",
    "你好！我能为你做些什么？":"你好！我能为你做些什么？",
    "停止生成":"停止生成",
    "清除对话内容":"清除对话内容",
    "前一页":"前一页",
    "你是谁":"你是谁",
    "六大茶类":"六大茶类",
    "帮我推荐一款茶叶":"帮我推荐一款茶叶",
    "波士顿倾茶事件":"波士顿倾茶事件",
    "后一页":"后一页",
    "在这里输入":"在这里输入",
    "你好":"你好",

    "今天":"今天",
    "请求失败，请重试。":"请求失败，请重试。",
    '小灵':"小灵",
    '清除上下文完成！':'清除上下文完成！',
    '已取消生成。':'已取消生成。',
    "你":"你",

    "回到顶部":'回到顶部',

    "春风吹绿苗":"春风吹绿苗",
    "晨朝掇灵芽":"晨朝掇灵芽",
    "蒸青是主流":"蒸青是主流",
    "茶香弥漫市":"茶香弥漫市",
    "圭璧无纤瑕":"圭璧无纤瑕",
    "古韵千年传":"古韵千年传",

    "西湖龙井":"西湖龙井",
    "碧螺春":"碧螺春",
    "黄山毛峰":"黄山毛峰",
    "玉露":"玉露",
    "滇青":"滇青",
    "白毫银针":"白毫银针",
    "白牡丹":"白牡丹",
    "寿眉":"寿眉",
    "贡眉":"贡眉",
    "黄山白茶":"黄山白茶",
    "海马宫茶":"海马宫茶",
    "蒙顶黄芽":"蒙顶黄芽",
    "霍山黄芽":"霍山黄芽",
    "广东大叶青":"广东大叶青",
    "北港毛尖":"北港毛尖",
    "铁观音":"铁观音",
    "大红袍":"大红袍",
    "肉桂":'肉桂',
    "水仙":"水仙",
    "北斗":'北斗',
    "祁门红茶":"祁门红茶",
    "滇红":"滇红",
    "正山小种":"正山小种",
    "金骏眉":"金骏眉",
    "安化黑茶":"安化黑茶",
    "普洱茶":"普洱茶",
    "六堡茶":"六堡茶",
    "泾阳茯砖茶":"泾阳茯砖茶",
    "千两茶":"千两茶",
    "坦洋工夫":"坦洋工夫",

    "皖":"皖",
    "湘":"湘",
    "苏":"苏",
    "浙":"浙",
    "黔":"黔",
    "川":"川",
    "滇":"滇",
    "桂":"桂",
    "闽":"闽",
    "鄂":"鄂",
    "陕":"陕",
    "赣":"赣",
    "粤":"粤",

    '河南':"河南",
    '贵州':"贵州",
    '江西':"江西",
    '安徽':"安徽",
    '浙江':"浙江",
    '江苏':"江苏",
    '四川':"四川",
    '陕西':"陕西",
    '湖南':"湖南",
    '湖北':"湖北",
    '广西':"广西",
    '福建':"福建",

    "绿茶":"绿茶",
    "红茶":"红茶",
    "白茶":"白茶",
    "黄茶":"黄茶",
    "乌龙茶":"乌龙茶",
    "黑茶":"黑茶",

    "加载中...":"加载中...",
    "第一次使用？":"第一次使用？",

    "安徽省":"安徽省",
    "黄山白茶-安徽省歙县":"黄山白茶-安徽省歙县",
    "黄山毛峰-安徽省黄山":"黄山毛峰-安徽省黄山",
    "祁门红茶-安徽省祁门县":"祁门红茶-安徽省祁门县",
    "霍山黄芽-安徽省霍山县":"霍山黄芽-安徽省霍山县",

    "湖南省":"湖南省",
    "安化黑茶、千两茶-湖南省益阳市安化县":"安化黑茶、千两茶-湖南省益阳市安化县",
    "北港毛尖-湖南省岳阳市北港":"北港毛尖-湖南省岳阳市北港",

    "浙江省":"浙江省",
    "西湖龙井-浙江省杭州市西湖龙井村":"西湖龙井-浙江省杭州市西湖龙井村",

    "贵州省":"贵州省",
    '海马宫茶-贵州省大方县海马宫村':"海马宫茶-贵州省大方县海马宫村",

    "云南省":"云南省",
    "滇青-云南省思茅市":"滇青-云南省思茅市",
    "滇青-云南省西双版纳":"滇青-云南省西双版纳",
    "滇青-云南省临沧市":"滇青-云南省临沧市",
    "滇青-云南省保山市":"滇青-云南省保山市",
    "滇青-云南省德宏傣族景颇族自治州":"滇青-云南省德宏傣族景颇族自治州",
    "滇青-云南省大理市":"滇青-云南省大理市",
    "滇红-云南省临沧市":"滇红-云南省临沧市",
    "滇红-云南省保山市":"滇红-云南省保山市",
    "滇红-云南省凤庆县":"滇红-云南省凤庆县",
    "普洱茶-云南省西双版纳":"普洱茶-云南省西双版纳",
    "普洱茶-云南省临沧市":"普洱茶-云南省临沧市",
    "普洱茶-云南省普洱市":"普洱茶-云南省普洱市",

    "广西壮族自治区":"广西壮族自治区",
    "六堡茶-广西壮族自治区梧州市六堡镇":"六堡茶-广西壮族自治区梧州市六堡镇",

    "江苏省":"江苏省",
    "碧螺春-江苏省苏州市":"碧螺春-江苏省苏州市",

    "四川省":"四川省",
    "蒙顶黄牙-四川省雅安市蒙顶山":"蒙顶黄牙-四川省雅安市蒙顶山",

    "福建省":"福建省",
    "白毫银针、白牡丹、寿眉-福建省福鼎市":"白毫银针、白牡丹、寿眉-福建省福鼎市",
    "白毫银针、寿眉、贡眉-福建省松溪县":"白毫银针、寿眉、贡眉-福建省松溪县",
    "白毫银针、寿眉-福建省柘荣县":"白毫银针、寿眉-福建省柘荣县",
    "白毫银针、寿眉、贡眉-福建省建阳市":"白毫银针、寿眉、贡眉-福建省建阳市",
    "白毫银针、白牡丹、寿眉、贡眉-福建省政和县":"白毫银针、白牡丹、寿眉、贡眉-福建省政和县",
    "贡眉-福建省建瓯市":"贡眉-福建省建瓯市",
    "贡眉-福建省浦城县":"贡眉-福建省浦城县",
    "正山小种-福建省武夷山":"正山小种-福建省武夷山",
    "金骏眉-福建省武夷山":"金骏眉-福建省武夷山",
    "铁观音-福建省泉州市安溪县":"铁观音-福建省泉州市安溪县",
    "大红袍、肉桂、北斗-福建省武夷山":"大红袍、肉桂、北斗-福建省武夷山",
    "水仙-福建省漳平市":"水仙-福建省漳平市",

    "陕西省":"陕西省",
    "泾阳茯砖茶-陕西省泾阳县":"泾阳茯砖茶-陕西省泾阳县",

    "湖北省":"湖北省",
    "玉露-湖北省恩施市":"玉露-湖北省恩施市",

    "广东省":"广东省",
    "广东大叶青-广东省韶关市":"广东大叶青-广东省韶关市",

    "广西省":"广西省",

    "元/斤":"元/斤",
    "平均价格":"平均价格",
    "发酵度":"发酵度",

    "关闭":"关闭",

   //详细介绍
   "<p>西湖龙井是中国十大名茶之一，属绿茶，其产于浙江省杭州市西湖龙井村周围群山，并因此得名，具有1200多年历史  。清乾隆游览杭州西湖时，盛赞西湖龙井茶，把狮峰山下胡公庙前的十八棵茶树封为“御茶”。西湖龙井按外形和内质的优次分作1～8级。</p><p>特级西湖龙井茶扁平光滑挺直，色泽嫩绿光润，香气鲜嫩清高，滋味鲜爽甘醇，叶底细嫩呈朵。清明节前采制的龙井茶简称明前龙井，美称女儿红，“院外风荷西子笑，明前龙井女儿红。”西湖龙井茶与西湖一样，是人、自然、文化三者的完美结晶，是西湖地域文化的重要载体。西湖龙井茶，外形扁平挺秀，色泽绿翠，内质清香味醇，泡在杯中，芽叶色绿。素以“色绿、香郁、味甘、形美”四绝称著。</p><p>春茶中的特级西湖龙井、浙江龙井外形扁平光滑，苗锋尖削，芽长于叶，色泽嫩绿，体表无茸毛；汤色嫩绿（黄）明亮；清香或嫩栗香，但有部分茶带高火香；滋味清爽或浓醇；叶底嫩绿，尚完整。其余各级龙井茶随着级别的下降，外形色泽由嫩绿→青绿→墨绿，茶身由小到大，茶条由光滑至粗糙；香味由嫩爽转向浓粗，四级茶开始有粗味；叶底由嫩芽转向对夹叶，色泽由嫩黄→青绿→黄褐。 夏秋龙井茶，色泽暗绿或深绿，茶身较大，体表无茸毛，汤色黄亮，有清香但较粗糙，滋味浓略涩，叶底黄亮，总体品质比同级春茶差。</p>":"<p>西湖龙井是中国十大名茶之一，属绿茶，其产于浙江省杭州市西湖龙井村周围群山，并因此得名，具有1200多年历史  。清乾隆游览杭州西湖时，盛赞西湖龙井茶，把狮峰山下胡公庙前的十八棵茶树封为“御茶”。西湖龙井按外形和内质的优次分作1～8级。</p><p>特级西湖龙井茶扁平光滑挺直，色泽嫩绿光润，香气鲜嫩清高，滋味鲜爽甘醇，叶底细嫩呈朵。清明节前采制的龙井茶简称明前龙井，美称女儿红，“院外风荷西子笑，明前龙井女儿红。”西湖龙井茶与西湖一样，是人、自然、文化三者的完美结晶，是西湖地域文化的重要载体。西湖龙井茶，外形扁平挺秀，色泽绿翠，内质清香味醇，泡在杯中，芽叶色绿。素以“色绿、香郁、味甘、形美”四绝称著。</p><p>春茶中的特级西湖龙井、浙江龙井外形扁平光滑，苗锋尖削，芽长于叶，色泽嫩绿，体表无茸毛；汤色嫩绿（黄）明亮；清香或嫩栗香，但有部分茶带高火香；滋味清爽或浓醇；叶底嫩绿，尚完整。其余各级龙井茶随着级别的下降，外形色泽由嫩绿→青绿→墨绿，茶身由小到大，茶条由光滑至粗糙；香味由嫩爽转向浓粗，四级茶开始有粗味；叶底由嫩芽转向对夹叶，色泽由嫩黄→青绿→黄褐。 夏秋龙井茶，色泽暗绿或深绿，茶身较大，体表无茸毛，汤色黄亮，有清香但较粗糙，滋味浓略涩，叶底黄亮，总体品质比同级春茶差。</p>",

   '<p>碧螺春是中国传统名茶，中国十大名茶之一，属于绿茶类，已有1000多年历史。碧螺春产于江苏省苏州市吴县太湖的东洞庭山及西洞庭山（今苏州吴中区）一带，所以又称“洞庭碧螺春”。</p><p>唐朝时就被列为贡品，古人们又称碧螺春为“功夫茶”、“新血茶”。高级的碧螺春，茶芽之细嫩0.5公斤干茶需要茶芽6-7万个。炒成后的干茶条索紧结，白毫显露，色泽银绿，翠碧诱人，卷曲成螺，产于春季，故名“碧螺春”。此茶冲泡后杯中白云翻滚，清香袭人，是中国的名茶。主要工序为杀青、揉捻、搓团显毫、炒青。</p>':'<p>碧螺春是中国传统名茶，中国十大名茶之一，属于绿茶类，已有1000多年历史。碧螺春产于江苏省苏州市吴县太湖的东洞庭山及西洞庭山（今苏州吴中区）一带，所以又称“洞庭碧螺春”。</p><p>唐朝时就被列为贡品，古人们又称碧螺春为“功夫茶”、“新血茶”。高级的碧螺春，茶芽之细嫩0.5公斤干茶需要茶芽6-7万个。炒成后的干茶条索紧结，白毫显露，色泽银绿，翠碧诱人，卷曲成螺，产于春季，故名“碧螺春”。此茶冲泡后杯中白云翻滚，清香袭人，是中国的名茶。主要工序为杀青、揉捻、搓团显毫、炒青。</p>',

   '<p>黄山毛峰是中国十大名茶之一，属于绿茶。产于安徽省黄山（徽州）一带，所以又称徽茶。由清代光绪年间谢裕大茶庄所创制。每年清明谷雨，选摘良种茶树“黄山种”、“黄山大叶种”等的初展肥壮嫩芽，手工炒制，该茶外形微卷，状似雀舌，绿中泛黄，银毫显露，且带有金黄色鱼叶（俗称黄金片）。入杯冲泡雾气结顶，汤色清碧微黄，叶底黄绿有活力，滋味醇甘，香气如兰，韵味深长。由于新制茶叶白毫披身，芽尖峰芒，且鲜叶采自黄山高峰，遂将该茶取名为黄山毛峰。</p>':'<p>黄山毛峰是中国十大名茶之一，属于绿茶。产于安徽省黄山（徽州）一带，所以又称徽茶。由清代光绪年间谢裕大茶庄所创制。每年清明谷雨，选摘良种茶树“黄山种”、“黄山大叶种”等的初展肥壮嫩芽，手工炒制，该茶外形微卷，状似雀舌，绿中泛黄，银毫显露，且带有金黄色鱼叶（俗称黄金片）。入杯冲泡雾气结顶，汤色清碧微黄，叶底黄绿有活力，滋味醇甘，香气如兰，韵味深长。由于新制茶叶白毫披身，芽尖峰芒，且鲜叶采自黄山高峰，遂将该茶取名为黄山毛峰。</p>',

   '<p>恩施玉露，湖北省恩施市特产，中国国家地理标志产品。 恩施玉露外形条索紧圆光滑、纤细挺直如针，色泽苍翠绿润。经沸水冲泡，芽叶复展如生，初时婷婷地悬浮杯中，继而沉降杯底，平伏完整，汤色嫩绿明亮，如玉露，香气清爽，滋味醇和。观其外形，赏心悦目；饮其茶汤，沁人心脾。</p><p>恩施玉露茶是中国传统蒸青绿茶，选用叶色浓绿的一芽一叶或一芽二叶鲜叶经蒸汽杀青制作而成。恩施玉露对采制的要求很严格，芽叶须细嫩、匀齐，成茶条索紧细匀整，紧圆光滑，色泽鲜绿，匀齐挺直，状如松针，白毫显露，色泽苍翠润绿；茶汤清澈明亮，香气清高持久，滋味鲜爽甘醇，叶底嫩匀明亮，色绿如玉。“三绿”：茶绿、汤绿、叶底绿，为其显著特点。日本自唐代从中国传入茶种及制茶方法后，至今仍主要采用蒸青方法制作绿茶，其玉露茶制法与恩施玉露大同小异，品质各有特色。</p><p>唐朝时就被列为贡品，古人们又称碧螺春为“功夫茶”、“新血茶”。高级的碧螺春，茶芽之细嫩0.5公斤干茶需要茶芽6-7万个。炒成后的干茶条索紧结，白毫显露，色泽银绿，翠碧诱人，卷曲成螺，产于春季，故名“碧螺春”。此茶冲泡后杯中白云翻滚，清香袭人，是中国的名茶。主要工序为杀青、揉捻、搓团显毫、炒青。</p>':'<p>恩施玉露，湖北省恩施市特产，中国国家地理标志产品。 恩施玉露外形条索紧圆光滑、纤细挺直如针，色泽苍翠绿润。经沸水冲泡，芽叶复展如生，初时婷婷地悬浮杯中，继而沉降杯底，平伏完整，汤色嫩绿明亮，如玉露，香气清爽，滋味醇和。观其外形，赏心悦目；饮其茶汤，沁人心脾。</p><p>恩施玉露茶是中国传统蒸青绿茶，选用叶色浓绿的一芽一叶或一芽二叶鲜叶经蒸汽杀青制作而成。恩施玉露对采制的要求很严格，芽叶须细嫩、匀齐，成茶条索紧细匀整，紧圆光滑，色泽鲜绿，匀齐挺直，状如松针，白毫显露，色泽苍翠润绿；茶汤清澈明亮，香气清高持久，滋味鲜爽甘醇，叶底嫩匀明亮，色绿如玉。“三绿”：茶绿、汤绿、叶底绿，为其显著特点。日本自唐代从中国传入茶种及制茶方法后，至今仍主要采用蒸青方法制作绿茶，其玉露茶制法与恩施玉露大同小异，品质各有特色。</p><p>唐朝时就被列为贡品，古人们又称碧螺春为“功夫茶”、“新血茶”。高级的碧螺春，茶芽之细嫩0.5公斤干茶需要茶芽6-7万个。炒成后的干茶条索紧结，白毫显露，色泽银绿，翠碧诱人，卷曲成螺，产于春季，故名“碧螺春”。此茶冲泡后杯中白云翻滚，清香袭人，是中国的名茶。主要工序为杀青、揉捻、搓团显毫、炒青。</p>',

   '<p>滇青，即未经压制的普洱茶散茶原料，云南有悠久历史的茶叶，是采用大叶种茶树的鲜叶，经过杀青、揉捻后，用太阳晒干而成的优质晒青茶。它与历史上经过后熟阶段（即后发酵）越陈越香的普洱茶品质风格各不相同。</p><p>历史上的滇青是按季节命名，有春尖、春中、春尾、二水和谷花等品质级别。现代的滇青就是选用晒青毛茶未经过后熟阶段直接筛制而成，分为：春蕊、春芽、春尖、甲配、乙配、丙配和春玉等花色等级，是云南绿茶中别具一格的优秀产品。滇青茶有经久耐泡的特点，除可作一般茶叶冲泡饮用外，还宜作烤茶冲泡饮用。</p>':'<p>滇青，即未经压制的普洱茶散茶原料，云南有悠久历史的茶叶，是采用大叶种茶树的鲜叶，经过杀青、揉捻后，用太阳晒干而成的优质晒青茶。它与历史上经过后熟阶段（即后发酵）越陈越香的普洱茶品质风格各不相同。</p><p>历史上的滇青是按季节命名，有春尖、春中、春尾、二水和谷花等品质级别。现代的滇青就是选用晒青毛茶未经过后熟阶段直接筛制而成，分为：春蕊、春芽、春尖、甲配、乙配、丙配和春玉等花色等级，是云南绿茶中别具一格的优秀产品。滇青茶有经久耐泡的特点，除可作一般茶叶冲泡饮用外，还宜作烤茶冲泡饮用。</p>',

   '<p>白毫银针，创制于1796年，是中国六大茶类之一的白茶，原产地在福建，主要产区为福鼎、柘荣、政和、松溪、建阳等地，属有中国十大名茶的称号，素有茶中“美女”、“茶王”之美称。其外观特征挺直似针，满披白毫，如银似雪，成品茶长约3cm。由于鲜叶原料全部是茶芽，且制成成品茶后，形状似针，白毫密被，色白如银，因此得名白毫银针。</p><p>白毫银针芽头肥壮，遍披白毫，挺直如针，色白似银。福鼎所产茶芽茸毛厚，色白富光泽，汤色浅杏黄，味清鲜爽口。政和所产，汤味醇厚，香气清芬。银针白毫原料采摘标准为春茶嫩梢萌发一芽一叶时即将其采下，然后用手指将真叶、鱼叶轻轻地予以剥离。剥出的茶芽均匀地薄摊于水筛上（一种竹筛），勿使重叠，置微弱日光下或通风荫外，晒凉至八、九成干，再用焙笼以30-40℃文火至足干即成。也有用烈日代替焙笼晒至全干的，称为毛针。毛针经筛取肥长茶芽，再用手工摘去梗子（俗称银针脚），并筛簸拣除叶片、碎片、寻质等，最后再用文火焙干，趁热装箱。</p>':'<p>白毫银针，创制于1796年，是中国六大茶类之一的白茶，原产地在福建，主要产区为福鼎、柘荣、政和、松溪、建阳等地，属有中国十大名茶的称号，素有茶中“美女”、“茶王”之美称。其外观特征挺直似针，满披白毫，如银似雪，成品茶长约3cm。由于鲜叶原料全部是茶芽，且制成成品茶后，形状似针，白毫密被，色白如银，因此得名白毫银针。</p><p>白毫银针芽头肥壮，遍披白毫，挺直如针，色白似银。福鼎所产茶芽茸毛厚，色白富光泽，汤色浅杏黄，味清鲜爽口。政和所产，汤味醇厚，香气清芬。银针白毫原料采摘标准为春茶嫩梢萌发一芽一叶时即将其采下，然后用手指将真叶、鱼叶轻轻地予以剥离。剥出的茶芽均匀地薄摊于水筛上（一种竹筛），勿使重叠，置微弱日光下或通风荫外，晒凉至八、九成干，再用焙笼以30-40℃文火至足干即成。也有用烈日代替焙笼晒至全干的，称为毛针。毛针经筛取肥长茶芽，再用手工摘去梗子（俗称银针脚），并筛簸拣除叶片、碎片、寻质等，最后再用文火焙干，趁热装箱。</p>',

   '<p>属于中国六大茶类之一的白茶品项，主产于中国福建省的南平市政和县、松溪县、建阳市和宁德市福鼎市，是中国福建省历史名茶。因其绿叶夹银白色毫心，形似花朵，冲泡后绿叶托着嫩芽，宛如蓓蕾初放，故得美名白牡丹。</p><p>白牡丹外形毫心肥壮，叶张肥嫩，呈波纹隆起，芽叶连枝，叶缘垂卷，叶态自然，叶色灰绿，夹以银白毫心，呈“抱心形”，叶背遍布洁白茸毛，叶缘向叶背微卷，芽叶连枝。汤色杏黄或橙黄清澈，叶底浅灰，叶脉微红，香味鲜醇。白牡丹冲泡后，碧绿的叶子衬托着嫩嫩的叶芽，形状优美，好似牡丹蓓蕾初放，十分恬淡高雅。冲泡后绿叶衬嫩芽，宛如蓓蕾初绽花朵，绚丽秀美；滋味清醇微甜，毫香鲜嫩持久，汤色杏黄明亮，叶底嫩匀完整，叶脉微红，布于绿叶之中，有“红装素裹”之誉。</p>':'<p>属于中国六大茶类之一的白茶品项，主产于中国福建省的南平市政和县、松溪县、建阳市和宁德市福鼎市，是中国福建省历史名茶。因其绿叶夹银白色毫心，形似花朵，冲泡后绿叶托着嫩芽，宛如蓓蕾初放，故得美名白牡丹。</p><p>白牡丹外形毫心肥壮，叶张肥嫩，呈波纹隆起，芽叶连枝，叶缘垂卷，叶态自然，叶色灰绿，夹以银白毫心，呈“抱心形”，叶背遍布洁白茸毛，叶缘向叶背微卷，芽叶连枝。汤色杏黄或橙黄清澈，叶底浅灰，叶脉微红，香味鲜醇。白牡丹冲泡后，碧绿的叶子衬托着嫩嫩的叶芽，形状优美，好似牡丹蓓蕾初放，十分恬淡高雅。冲泡后绿叶衬嫩芽，宛如蓓蕾初绽花朵，绚丽秀美；滋味清醇微甜，毫香鲜嫩持久，汤色杏黄明亮，叶底嫩匀完整，叶脉微红，布于绿叶之中，有“红装素裹”之誉。</p>',

   '<p>寿眉，乃以福鼎大白、福鼎白茶树制成的白茶。寿眉叶张稍肥嫩，芽叶连枝，无老梗，叶整卷如眉，香气清纯。其中用茶芽叶制成的毛茶称为“小白”，以区别于福鼎大白茶、政和大白茶茶树芽叶制成的“大白”毛茶。菜茶茶芽曾用以制造白毫银针，其后改用大白制白毫银针和白牡丹，而小白则用以制造贡眉。</p><p>优质寿眉毫心显而多，色泽翠绿，汤色橙黄或深黄，叶底匀整、柔软、鲜亮，叶张主脉迎光透视呈红色，味醇爽，香鲜纯。其采摘标准为一芽二叶至一芽二、三叶，要求含有白毫。优质寿眉色泽翠绿，汤色橙黄。</p>':'<p>寿眉，乃以福鼎大白、福鼎白茶树制成的白茶。寿眉叶张稍肥嫩，芽叶连枝，无老梗，叶整卷如眉，香气清纯。其中用茶芽叶制成的毛茶称为“小白”，以区别于福鼎大白茶、政和大白茶茶树芽叶制成的“大白”毛茶。菜茶茶芽曾用以制造白毫银针，其后改用大白制白毫银针和白牡丹，而小白则用以制造贡眉。</p><p>优质寿眉毫心显而多，色泽翠绿，汤色橙黄或深黄，叶底匀整、柔软、鲜亮，叶张主脉迎光透视呈红色，味醇爽，香鲜纯。其采摘标准为一芽二叶至一芽二、三叶，要求含有白毫。优质寿眉色泽翠绿，汤色橙黄。</p>',

   '<p>贡眉又称为寿眉，属于中国六大茶类之一的白茶品项，主产于中国福建省的南平市的松溪县、政和县、建阳市、建瓯市、浦城县等地，是白茶中产量最高的一个品项，其产量约占到了白茶总产量的50%以上。</p><p>优质的贡眉成品茶毫心明显，茸毫色白且多，干茶色泽翠绿，冲泡后汤色呈橙色或深黄色，叶底匀整、柔软、鲜亮，叶片迎光看去，可透视出主脉的红色，品饮时感觉滋味醇爽，香气鲜纯。</p>':'<p>贡眉又称为寿眉，属于中国六大茶类之一的白茶品项，主产于中国福建省的南平市的松溪县、政和县、建阳市、建瓯市、浦城县等地，是白茶中产量最高的一个品项，其产量约占到了白茶总产量的50%以上。</p><p>优质的贡眉成品茶毫心明显，茸毫色白且多，干茶色泽翠绿，冲泡后汤色呈橙色或深黄色，叶底匀整、柔软、鲜亮，叶片迎光看去，可透视出主脉的红色，品饮时感觉滋味醇爽，香气鲜纯。</p>',

   '<p>黄山白茶，安徽省歙县特产，国家地理标志产品。黄山白茶富含氨基酸、铁、锌、硒等营养元素，特别是氨基酸含量较高,高达9.2%，远超浙江安吉白茶，由于其酚氨比较低，故茶汤滋味极其鲜醇。</p><p>黄山白茶芽白如玉、叶薄如纸。叶脉呈乳白色，冲泡后似凤羽有兰花香，汤色清澈，鲜爽甜香。理化指标：水浸出物≥35%，游离氨基酸总量（以谷氨酸计）≥7.0%。</p>':'<p>黄山白茶，安徽省歙县特产，国家地理标志产品。黄山白茶富含氨基酸、铁、锌、硒等营养元素，特别是氨基酸含量较高,高达9.2%，远超浙江安吉白茶，由于其酚氨比较低，故茶汤滋味极其鲜醇。</p><p>黄山白茶芽白如玉、叶薄如纸。叶脉呈乳白色，冲泡后似凤羽有兰花香，汤色清澈，鲜爽甜香。理化指标：水浸出物≥35%，游离氨基酸总量（以谷氨酸计）≥7.0%。</p>',

   '<p>海马宫茶属黄茶类名茶。具有条索紧结卷曲，茸毛显露，青高味醇，回味甘甜，汤色黄绿明亮，叶底嫩黄匀整明亮的特点。</p><p>海马宫茶，由贵州茶农创制于乾隆年间。产于贵州省大方县的老鹰岩脚下的海马宫村。海马宫茶采于当地中，小群体品种，具有茸毛多，持嫩性强的特性。谷雨前后开采。采摘标准；一级茶为一芽一叶初展；二级茶为一芽二叶，三级茶为一芽三叶。海马宫茶属黄茶类名茶。具有条索紧结卷曲，茸毛显露，青高味醇，回味甘甜，汤色黄绿明亮，叶底嫩黄匀整明亮的特点。</p>':'<p>海马宫茶属黄茶类名茶。具有条索紧结卷曲，茸毛显露，青高味醇，回味甘甜，汤色黄绿明亮，叶底嫩黄匀整明亮的特点。</p><p>海马宫茶，由贵州茶农创制于乾隆年间。产于贵州省大方县的老鹰岩脚下的海马宫村。海马宫茶采于当地中，小群体品种，具有茸毛多，持嫩性强的特性。谷雨前后开采。采摘标准；一级茶为一芽一叶初展；二级茶为一芽二叶，三级茶为一芽三叶。海马宫茶属黄茶类名茶。具有条索紧结卷曲，茸毛显露，青高味醇，回味甘甜，汤色黄绿明亮，叶底嫩黄匀整明亮的特点。</p>',

   '<p>蒙顶黄芽，是芽形黄茶之一，产于四川省雅安市蒙顶山。蒙顶茶栽培始于西汉，距今已有二千年的历史，古时为贡品供历代皇帝享用，新中国成立后曾被评为全国十大名茶之一。蒙顶黄芽外形扁直，芽条匀整，色泽嫩黄，芽毫显露，花香幽长，汤色黄亮透碧，滋味鲜醇回甘，叶底全芽嫩黄采摘于春分时节，茶树上有10%的芽头鳞片展开，即可开园采摘。选圆肥单芽和一芽一叶初展的芽头，经复杂制作工艺，使成茶芽条匀整，扁平挺直，色泽黄润，金毫显露；汤色黄中透碧，甜香鲜嫩，甘醇鲜爽。为黄茶之极品。</p>':'<p>蒙顶黄芽，是芽形黄茶之一，产于四川省雅安市蒙顶山。蒙顶茶栽培始于西汉，距今已有二千年的历史，古时为贡品供历代皇帝享用，新中国成立后曾被评为全国十大名茶之一。蒙顶黄芽外形扁直，芽条匀整，色泽嫩黄，芽毫显露，花香幽长，汤色黄亮透碧，滋味鲜醇回甘，叶底全芽嫩黄采摘于春分时节，茶树上有10%的芽头鳞片展开，即可开园采摘。选圆肥单芽和一芽一叶初展的芽头，经复杂制作工艺，使成茶芽条匀整，扁平挺直，色泽黄润，金毫显露；汤色黄中透碧，甜香鲜嫩，甘醇鲜爽。为黄茶之极品。</p>',

   '<p>霍山黄芽，安徽省霍山县特产，国家地理标志产品。</p><p>霍山黄芽依其品质分为特一级、特二级、一级和二级。外形挺直微展，色泽黄绿披毫，香气清香持久，汤色黄绿明亮，滋味浓厚鲜醇回甘，叶底微黄明亮。</p><p>2006年12月，霍山黄芽成功获批国家地理标志保护产品称号。</p>':'<p>霍山黄芽，安徽省霍山县特产，国家地理标志产品。</p><p>霍山黄芽依其品质分为特一级、特二级、一级和二级。外形挺直微展，色泽黄绿披毫，香气清香持久，汤色黄绿明亮，滋味浓厚鲜醇回甘，叶底微黄明亮。</p><p>2006年12月，霍山黄芽成功获批国家地理标志保护产品称号。</p>',

   '<p>大叶青茶为广东的特产。大叶青茶也称广东大叶青，主要产于广东省韶关、肇庆、湛江等县市、属于黄茶，是黄大茶的代表品种之一。制法是先萎凋后杀青，再揉捻闷堆。这与其它黄茶不同。产品品质具有黄茶的一般特点。所以也归属共同茶类。其产地为广东省韶关、肇庆、湛江等县市。广东大叶青为属黄茶类，但与其他黄茶制法不同，其先萎凋后杀青，再揉捻闷堆。杀青前的萎凋和揉捻后闷黄的主要目的是消除青气涩味，促进香味醇和纯正。</p>':'<p>大叶青茶为广东的特产。大叶青茶也称广东大叶青，主要产于广东省韶关、肇庆、湛江等县市、属于黄茶，是黄大茶的代表品种之一。制法是先萎凋后杀青，再揉捻闷堆。这与其它黄茶不同。产品品质具有黄茶的一般特点。所以也归属共同茶类。其产地为广东省韶关、肇庆、湛江等县市。广东大叶青为属黄茶类，但与其他黄茶制法不同，其先萎凋后杀青，再揉捻闷堆。杀青前的萎凋和揉捻后闷黄的主要目的是消除青气涩味，促进香味醇和纯正。</p>',

   '<p>北港毛尖以注册商标“北港”命名，唐代称“邕（yōng）湖茶”，属黄茶类，产于湖南省岳阳市北港。在加工技术中，通过热闷措施的摧化作用，破坏叶绿素，使不溶性碳水化合物部分转化成可溶性，儿茶素类发生非酶性氧化和异构化作用，其转化产物与蛋白质水解的氨基酸结合，产生新的香味物质，达到茶叶黄化，香味鲜醇回甘。</p><p>1987年在湖南全省名优茶评比中被评为全省名茶。</p>':'<p>北港毛尖以注册商标“北港”命名，唐代称“邕（yōng）湖茶”，属黄茶类，产于湖南省岳阳市北港。在加工技术中，通过热闷措施的摧化作用，破坏叶绿素，使不溶性碳水化合物部分转化成可溶性，儿茶素类发生非酶性氧化和异构化作用，其转化产物与蛋白质水解的氨基酸结合，产生新的香味物质，达到茶叶黄化，香味鲜醇回甘。</p><p>1987年在湖南全省名优茶评比中被评为全省名茶。</p>',

   '<p>铁观音（tiě guān yīn）茶，中国传统名茶，属于青茶类，是中国十大名茶之一。原产于福建泉州市安溪县西坪镇，发现于1723—1735年。“铁观音”既是茶名，也是茶树品种名，铁观音茶介于绿茶和红茶之间，属于半发酵茶类，铁观音独具“观音韵”，清香雅韵，冲泡后有天然的兰花香，滋味纯浓，香气馥郁持久，有“七泡有余香”之誉 。除具有一般茶叶的保健功能外，还具有抗衰老、抗动脉硬化、防治糖尿病、减肥健美、防治龋齿、清热降火，敌烟醒酒等功效。</p><p>铁观音含有较高的氨基酸、维生素、矿物质、茶多酚和生物碱，有多种营养和药效成分，具有养生保健的功能。于民国八年自福建安溪引进木栅区试种，分“红心铁观音”及“青心铁观音”两种，主要产区在文山期树属横张型，枝干粗硬，叶较稀松，芽少叶厚，产量不高，但制包种茶品质高，产期较青心乌龙晚。其树形稍，叶呈椭圆形，叶厚肉多。叶片平坦展开。</p>':'<p>铁观音（tiě guān yīn）茶，中国传统名茶，属于青茶类，是中国十大名茶之一。原产于福建泉州市安溪县西坪镇，发现于1723—1735年。“铁观音”既是茶名，也是茶树品种名，铁观音茶介于绿茶和红茶之间，属于半发酵茶类，铁观音独具“观音韵”，清香雅韵，冲泡后有天然的兰花香，滋味纯浓，香气馥郁持久，有“七泡有余香”之誉 。除具有一般茶叶的保健功能外，还具有抗衰老、抗动脉硬化、防治糖尿病、减肥健美、防治龋齿、清热降火，敌烟醒酒等功效。</p><p>铁观音含有较高的氨基酸、维生素、矿物质、茶多酚和生物碱，有多种营养和药效成分，具有养生保健的功能。于民国八年自福建安溪引进木栅区试种，分“红心铁观音”及“青心铁观音”两种，主要产区在文山期树属横张型，枝干粗硬，叶较稀松，芽少叶厚，产量不高，但制包种茶品质高，产期较青心乌龙晚。其树形稍，叶呈椭圆形，叶厚肉多。叶片平坦展开。</p>',

   '<p>大红袍，产于福建武夷山，属乌龙茶，品质优异。中国特种名茶。其外形条索紧结，色泽绿褐鲜润，冲泡后汤色橙黄明亮，叶片红绿相间。品质最突出之处是香气馥郁有兰花香，香高而持久，“岩韵”明显。除与一般茶叶具有提神益思，消除疲劳、生津利尿、解热防暑、杀菌消炎、解毒防病、消食去腻、减肥健美等保健功能外，还具有防癌症、降血脂、抗衰老、等特殊功效。大红袍很耐冲泡，冲泡七、八次仍有香味。品饮“大红袍”茶，必须按“工夫茶”小壶小杯细品慢饮的程式，才能真正品尝到岩茶之颠的禅茶韵味。注重活 、甘、清、香。</p>':'<p>大红袍，产于福建武夷山，属乌龙茶，品质优异。中国特种名茶。其外形条索紧结，色泽绿褐鲜润，冲泡后汤色橙黄明亮，叶片红绿相间。品质最突出之处是香气馥郁有兰花香，香高而持久，“岩韵”明显。除与一般茶叶具有提神益思，消除疲劳、生津利尿、解热防暑、杀菌消炎、解毒防病、消食去腻、减肥健美等保健功能外，还具有防癌症、降血脂、抗衰老、等特殊功效。大红袍很耐冲泡，冲泡七、八次仍有香味。品饮“大红袍”茶，必须按“工夫茶”小壶小杯细品慢饮的程式，才能真正品尝到岩茶之颠的禅茶韵味。注重活 、甘、清、香。</p>',

   '<p>《武夷茶经》里表述：“肉桂，原产马枕峰……已有100多年历史，1985年福建省农作物品种审定委员会认定为省级品种”；《武夷岩茶名丛录》里也有表述：“肉桂，原产马枕峰，慧苑坑等处也有此相同之树。” 该茶是以肉桂良种茶树鲜叶，用武夷岩茶的制作方法而制成的乌龙茶，为武夷岩茶中的高香品种。</p><p>本世纪四十年代初已是武夷山茶园栽种的十个品种之一，到六十年代以来，由于其品质特殊，逐渐为人们认可，种植面积逐年扩大，现已发展到武夷山的水帘洞、牛栏坑、马头岩、天心岩、慧苑坑、鹰嘴岩、流香涧、竹窠、悟源涧、九龙窠等地，并且正在大力繁育推广，现已成为武夷岩茶中的主要品种。</p>':'<p>《武夷茶经》里表述：“肉桂，原产马枕峰……已有100多年历史，1985年福建省农作物品种审定委员会认定为省级品种”；《武夷岩茶名丛录》里也有表述：“肉桂，原产马枕峰，慧苑坑等处也有此相同之树。” 该茶是以肉桂良种茶树鲜叶，用武夷岩茶的制作方法而制成的乌龙茶，为武夷岩茶中的高香品种。</p><p>本世纪四十年代初已是武夷山茶园栽种的十个品种之一，到六十年代以来，由于其品质特殊，逐渐为人们认可，种植面积逐年扩大，现已发展到武夷山的水帘洞、牛栏坑、马头岩、天心岩、慧苑坑、鹰嘴岩、流香涧、竹窠、悟源涧、九龙窠等地，并且正在大力繁育推广，现已成为武夷岩茶中的主要品种。</p>',

   '<p>水仙茶是福建茶农创制的名茶，属于中国茶叶优良品种之一，是福建乌龙茶类中的一种。原产于闽北。一千年前，建阳、建瓯一带就有这种茶树，但人工栽培却是距今三百多年前的清康熙年间（1662-1722）。水仙茶列“中国国家级茶树良种”48个之首，又是全国41个半乔木大叶型茶树良种的第一个，发源于福建省建阳市唯一的茶树良种。汤色橙黄、香如兰花、滋味醇厚回甘。1985年全国农作物品种审定委员会认定为国家品种，编号GS13009—1985。</p>':'<p>水仙茶是福建茶农创制的名茶，属于中国茶叶优良品种之一，是福建乌龙茶类中的一种。原产于闽北。一千年前，建阳、建瓯一带就有这种茶树，但人工栽培却是距今三百多年前的清康熙年间（1662-1722）。水仙茶列“中国国家级茶树良种”48个之首，又是全国41个半乔木大叶型茶树良种的第一个，发源于福建省建阳市唯一的茶树良种。汤色橙黄、香如兰花、滋味醇厚回甘。1985年全国农作物品种审定委员会认定为国家品种，编号GS13009—1985。</p>',

   '<p>北斗：原名北斗一号，武夷山名丛之一。原产于北斗峰（北斗峰在三姑石后面，山势陡峭，钟灵毓秀。相传1400多年前道家取名）现已有60多年的栽培历史，主要分布在武夷山武夷山正岩产区。北斗：无性系，灌木型，中叶类，中生种，品质优，色泽绿褐，香气浓郁鲜爽，滋味浓厚回甘，岩韵明显。抗寒性、抗旱性强。扦插繁殖能力强，成活率高。北斗茶为半发酵茶，其特殊的焙火工艺，不但茶叶品质提高，茶香稳定，还可以延长存放时间。北斗茶干香，清纯辛锐，幽雅秀气，香高持久。一泡入口最明显的就是清澈，细品清纯顺口，回甘甜持久，汤滑甘鲜醇润可口，滋味醇厚。</p>':'<p>北斗：原名北斗一号，武夷山名丛之一。原产于北斗峰（北斗峰在三姑石后面，山势陡峭，钟灵毓秀。相传1400多年前道家取名）现已有60多年的栽培历史，主要分布在武夷山武夷山正岩产区。北斗：无性系，灌木型，中叶类，中生种，品质优，色泽绿褐，香气浓郁鲜爽，滋味浓厚回甘，岩韵明显。抗寒性、抗旱性强。扦插繁殖能力强，成活率高。北斗茶为半发酵茶，其特殊的焙火工艺，不但茶叶品质提高，茶香稳定，还可以延长存放时间。北斗茶干香，清纯辛锐，幽雅秀气，香高持久。一泡入口最明显的就是清澈，细品清纯顺口，回甘甜持久，汤滑甘鲜醇润可口，滋味醇厚。</p>',

   '<p>祁门红茶，又称祁红，是中国安徽省黄山市祁门县出产的一种名优红茶。祁门红茶起源于明代，具有400多年的历史。它以其独特的外形、香气和口感而闻名于世。</p><p>祁门红茶的茶叶选自祁门县境内的高山茶园，采用传统的手工制作工艺。茶叶外形条索紧结，色泽乌润，金毫显露。冲泡时，茶汤呈红褐色，香气浓郁，口感醇厚。</p><p>祁门红茶的品质受土壤、气候和制作工艺的影响，因此，不同年份和产区的祁门红茶呈现出不同的特点。一般来说，祁门红茶具有独特的果香和花香，同时带有一定的甜味和淡淡的苦涩感。它富含多种有益物质，如茶多酚、咖啡因和氨基酸，具有提神醒脑、消除疲劳、抗氧化等功效。</p><p>祁门红茶是中国四大名茶之一，也是国内外茶叶市场上备受追捧的茶品之一。它被誉为“红茶之王”，享有“色香味俱佳，汤色红艳明亮，滋味醇和回甘”的美誉。无论是作为日常饮品还是送礼品，祁门红茶都是一种受欢迎的选择。</p>':'<p>祁门红茶，又称祁红，是中国安徽省黄山市祁门县出产的一种名优红茶。祁门红茶起源于明代，具有400多年的历史。它以其独特的外形、香气和口感而闻名于世。</p><p>祁门红茶的茶叶选自祁门县境内的高山茶园，采用传统的手工制作工艺。茶叶外形条索紧结，色泽乌润，金毫显露。冲泡时，茶汤呈红褐色，香气浓郁，口感醇厚。</p><p>祁门红茶的品质受土壤、气候和制作工艺的影响，因此，不同年份和产区的祁门红茶呈现出不同的特点。一般来说，祁门红茶具有独特的果香和花香，同时带有一定的甜味和淡淡的苦涩感。它富含多种有益物质，如茶多酚、咖啡因和氨基酸，具有提神醒脑、消除疲劳、抗氧化等功效。</p><p>祁门红茶是中国四大名茶之一，也是国内外茶叶市场上备受追捧的茶品之一。它被誉为“红茶之王”，享有“色香味俱佳，汤色红艳明亮，滋味醇和回甘”的美誉。无论是作为日常饮品还是送礼品，祁门红茶都是一种受欢迎的选择。</p>',

   '<p>滇红是一种优质红茶，产于中国云南省的滇西高原地区。它以其独特的香气、醇厚的口感和深红色的汤色而闻名。滇红茶采用优质的茶树叶制作，经过摊晾、杀青、揉捻、发酵等工艺过程而成。</p><p>滇红茶的叶片形状扁平整齐，色泽乌润，散发出浓郁的花香和果香。其汤色鲜艳红亮，入口后有浓郁的甘甜味和花果香气，口感醇厚且回甘。滇红茶适宜冲泡，可多次冲泡，每一次冲泡都能释放出不同的香气和口感。</p><p>滇红茶在国内外享有很高的声誉，被誉为世界三大红茶之一。它不仅是中国传统的名茶之一，也是中国主要的出口茶叶之一。滇红茶以其独特的品质和口感受到了全球茶叶爱好者的喜爱和追捧。</p>':'<p>滇红是一种优质红茶，产于中国云南省的滇西高原地区。它以其独特的香气、醇厚的口感和深红色的汤色而闻名。滇红茶采用优质的茶树叶制作，经过摊晾、杀青、揉捻、发酵等工艺过程而成。</p><p>滇红茶的叶片形状扁平整齐，色泽乌润，散发出浓郁的花香和果香。其汤色鲜艳红亮，入口后有浓郁的甘甜味和花果香气，口感醇厚且回甘。滇红茶适宜冲泡，可多次冲泡，每一次冲泡都能释放出不同的香气和口感。</p><p>滇红茶在国内外享有很高的声誉，被誉为世界三大红茶之一。它不仅是中国传统的名茶之一，也是中国主要的出口茶叶之一。滇红茶以其独特的品质和口感受到了全球茶叶爱好者的喜爱和追捧。</p>',

   '<p>《正山小种，又称“正山小种红茶”，是中国福建省武夷山产区的一种传统红茶。它得名于产地的“正山”和其茶叶的形状较小的特点。正山小种红茶的制作工艺独特，采用独特的“炒青”工艺，即将新鲜茶叶炒制至半发酵状态，然后经过揉捻、干燥等工序制成。</p><p>正山小种红茶的外形呈细小、紧结的条索状，色泽乌润，香气鲜爽，滋味醇厚，回甘悠长。其茶汤呈红褐色，清澈透亮。正山小种红茶具有浓郁的烟熏香气和独特的“岩韵”，口感丰满柔和，不苦涩，且富含茶多酚和咖啡碱等营养物质。</p><p>正山小种红茶是中国四大名茶之一，享有盛誉。其历史悠久，起源于18世纪，曾是英国皇家贵族的御茶之品。如今，正山小种红茶已成为中国主要的红茶出口品种之一，深受国内外茶叶爱好者的喜爱。它不仅是一种美味的饮品，还被认为具有降脂减肥、改善血液循环、提神醒脑等功效。</p>':'<p>《正山小种，又称“正山小种红茶”，是中国福建省武夷山产区的一种传统红茶。它得名于产地的“正山”和其茶叶的形状较小的特点。正山小种红茶的制作工艺独特，采用独特的“炒青”工艺，即将新鲜茶叶炒制至半发酵状态，然后经过揉捻、干燥等工序制成。</p><p>正山小种红茶的外形呈细小、紧结的条索状，色泽乌润，香气鲜爽，滋味醇厚，回甘悠长。其茶汤呈红褐色，清澈透亮。正山小种红茶具有浓郁的烟熏香气和独特的“岩韵”，口感丰满柔和，不苦涩，且富含茶多酚和咖啡碱等营养物质。</p><p>正山小种红茶是中国四大名茶之一，享有盛誉。其历史悠久，起源于18世纪，曾是英国皇家贵族的御茶之品。如今，正山小种红茶已成为中国主要的红茶出口品种之一，深受国内外茶叶爱好者的喜爱。它不仅是一种美味的饮品，还被认为具有降脂减肥、改善血液循环、提神醒脑等功效。</p>',

   '<p>金骏眉是中国传统名茶之一产于中国福建省武夷山地区，是武夷岩茶的代表之一金骏眉茶，属于红茶中正山小种的分支，原产于福建省武夷山市桐木村。由正山小种红茶第二十四代传承人江元勋带领团队在传统工艺的基础上通过创新融合于2005年研制出的新品种红茶。</p><p>金骏眉茶叶的汤色清亮透明，香气高扬，口感鲜爽，回甘持久。它具有独特的花果香气，口感醇厚，滋味鲜爽，汤色明亮，叶底嫩绿。金骏眉茶具有清热解毒、提神醒脑、消食健胃等功效，常饮有助于提高免疫力，改善消化系统功能，对于保持健康有一定的帮助。</p><p>金骏眉之所以名贵，是因为全程都由制茶师傅手工制作，每500g金骏眉需要数万颗的茶叶鲜芽尖，采摘武夷山自然保护区内的高山原生态小种新鲜茶芽，然后经过一系列复杂的萎凋、摇青、发酵、揉捻等加工步骤而得以完成。金骏眉是难得的茶中珍品，外形细小紧密，伴有金黄色的茶绒茶毫，汤色金黄，入口甘爽。</p>':'<p>金骏眉是中国传统名茶之一产于中国福建省武夷山地区，是武夷岩茶的代表之一金骏眉茶，属于红茶中正山小种的分支，原产于福建省武夷山市桐木村。由正山小种红茶第二十四代传承人江元勋带领团队在传统工艺的基础上通过创新融合于2005年研制出的新品种红茶。</p><p>金骏眉茶叶的汤色清亮透明，香气高扬，口感鲜爽，回甘持久。它具有独特的花果香气，口感醇厚，滋味鲜爽，汤色明亮，叶底嫩绿。金骏眉茶具有清热解毒、提神醒脑、消食健胃等功效，常饮有助于提高免疫力，改善消化系统功能，对于保持健康有一定的帮助。</p><p>金骏眉之所以名贵，是因为全程都由制茶师傅手工制作，每500g金骏眉需要数万颗的茶叶鲜芽尖，采摘武夷山自然保护区内的高山原生态小种新鲜茶芽，然后经过一系列复杂的萎凋、摇青、发酵、揉捻等加工步骤而得以完成。金骏眉是难得的茶中珍品，外形细小紧密，伴有金黄色的茶绒茶毫，汤色金黄，入口甘爽。</p>',

   '<p>安化黑茶是一种中国传统的发酵茶，产于湖南省安化县。它是以优质毛茶为原料，经过揉捻、杀青、发酵、烘干等工艺制作而成。</p><p>安化黑茶是中国黑茶的始祖，在唐代（856年）的史料中记载为“渠江薄片”，曾列为朝廷贡品，明嘉靖三年（1524年）就正式创制出了安化黑茶。至16世纪末期，安化黑茶已位居中国领先地位，万历年间被定为官茶，大量远销西北。</p><p>安化黑茶外观呈黑褐色，茶汤呈红褐色，滋味醇厚、甘甜，香气独特，有“茶中美酒”之称。安化黑茶的制作历史悠久，已有数百年的历史，是中国茶叶文化的重要组成部分。除了作为一种饮品外，安化黑茶还有一定的药用价值，被广泛用于调理身体和治疗疾病。</p>':'<p>安化黑茶是一种中国传统的发酵茶，产于湖南省安化县。它是以优质毛茶为原料，经过揉捻、杀青、发酵、烘干等工艺制作而成。</p><p>安化黑茶是中国黑茶的始祖，在唐代（856年）的史料中记载为“渠江薄片”，曾列为朝廷贡品，明嘉靖三年（1524年）就正式创制出了安化黑茶。至16世纪末期，安化黑茶已位居中国领先地位，万历年间被定为官茶，大量远销西北。</p><p>安化黑茶外观呈黑褐色，茶汤呈红褐色，滋味醇厚、甘甜，香气独特，有“茶中美酒”之称。安化黑茶的制作历史悠久，已有数百年的历史，是中国茶叶文化的重要组成部分。除了作为一种饮品外，安化黑茶还有一定的药用价值，被广泛用于调理身体和治疗疾病。</p>',

   '<p>普洱茶是一种以云南大叶种茶为原料，经过特殊的发酵和储藏工艺制成的茶叶。其历史可以追溯到公元前3000年左右，是中国茶叶中的一种古老品种。</p><p>普洱茶的特点是色泽红褐，香气独特，味道醇厚，有助于消化和降低胆固醇。普洱茶还有很多功效，如促进血液循环、降低血压、减肥等。普洱茶的品质和价值主要取决于原料的品质、制作工艺和储藏时间。</p>':'<p>普洱茶是一种以云南大叶种茶为原料，经过特殊的发酵和储藏工艺制成的茶叶。其历史可以追溯到公元前3000年左右，是中国茶叶中的一种古老品种。</p><p>普洱茶的特点是色泽红褐，香气独特，味道醇厚，有助于消化和降低胆固醇。普洱茶还有很多功效，如促进血液循环、降低血压、减肥等。普洱茶的品质和价值主要取决于原料的品质、制作工艺和储藏时间。</p>',

   '<p>六堡茶是中国传统名茶之一，产于广西壮族自治区梧州市的六堡镇，因此得名。六堡茶的历史可以追溯到明朝，已有几百年的栽培和制作历史。</p><p>六堡茶以其独特的香气和口感而闻名。它是一种发酵度较高的黑茶，经过采摘、萎凋、揉捻、发酵、炒制等工序制成。六堡茶的茶叶形状扁平，色泽乌润，茶汤呈红褐色。</p><p>六堡茶的香气浓郁，带有独特的陈香味，入口后回甘顺滑。它具有温暖身体、消食化滞、降脂减肥等功效。六堡茶还含有丰富的茶多酚和咖啡碱，有助于提神醒脑，增强免疫力。六堡茶有多个品种，其中最有名的是六堡大茶、小茶和细茶。六堡大茶叶片较大，茶汤颜色深沉，口感醇厚；小茶叶片较小，茶汤颜色较浅，口感清爽；细茶叶片细小，茶汤颜色红艳，口感浓郁。</p><p>在中国茶文化中，六堡茶被视为一种高品质的茶叶，常作为馈赠礼品或在重要场合上供茶。它的独特风味和历史传承使其成为茶叶爱好者和收藏家们追捧的对象。</p>':'<p>六堡茶是中国传统名茶之一，产于广西壮族自治区梧州市的六堡镇，因此得名。六堡茶的历史可以追溯到明朝，已有几百年的栽培和制作历史。</p><p>六堡茶以其独特的香气和口感而闻名。它是一种发酵度较高的黑茶，经过采摘、萎凋、揉捻、发酵、炒制等工序制成。六堡茶的茶叶形状扁平，色泽乌润，茶汤呈红褐色。</p><p>六堡茶的香气浓郁，带有独特的陈香味，入口后回甘顺滑。它具有温暖身体、消食化滞、降脂减肥等功效。六堡茶还含有丰富的茶多酚和咖啡碱，有助于提神醒脑，增强免疫力。六堡茶有多个品种，其中最有名的是六堡大茶、小茶和细茶。六堡大茶叶片较大，茶汤颜色深沉，口感醇厚；小茶叶片较小，茶汤颜色较浅，口感清爽；细茶叶片细小，茶汤颜色红艳，口感浓郁。</p><p>在中国茶文化中，六堡茶被视为一种高品质的茶叶，常作为馈赠礼品或在重要场合上供茶。它的独特风味和历史传承使其成为茶叶爱好者和收藏家们追捧的对象。</p>',

   '<p>泾阳茯砖茶是中国陕西省泾阳县出产的一种特色茶。它是一种压制茶，将新鲜的茶叶经过摊晾、杀青、揉捻、压制等工艺制成砖状。泾阳茯砖茶的茶叶形状规整，色泽深绿。</p><p>泾阳茯砖茶以其独特的香气和口感而闻名。它具有清香高爽、甘醇顺滑的特点。茯砖茶的茶汤呈黄绿色，清澈透亮。它的口感清爽宜人，带有一丝丝的甘甜。</p><p>泾阳茯砖茶具有多种保健功效。它含有丰富的茶多酚、咖啡碱和维生素等营养物质，有助于提神醒脑、消食化滞、降脂减肥等。同时，茯砖茶还具有抗氧化、抗衰老的作用，有助于保护心血管健康。</p>':'<p>泾阳茯砖茶是中国陕西省泾阳县出产的一种特色茶。它是一种压制茶，将新鲜的茶叶经过摊晾、杀青、揉捻、压制等工艺制成砖状。泾阳茯砖茶的茶叶形状规整，色泽深绿。</p><p>泾阳茯砖茶以其独特的香气和口感而闻名。它具有清香高爽、甘醇顺滑的特点。茯砖茶的茶汤呈黄绿色，清澈透亮。它的口感清爽宜人，带有一丝丝的甘甜。</p><p>泾阳茯砖茶具有多种保健功效。它含有丰富的茶多酚、咖啡碱和维生素等营养物质，有助于提神醒脑、消食化滞、降脂减肥等。同时，茯砖茶还具有抗氧化、抗衰老的作用，有助于保护心血管健康。</p>',

   '<p>千两茶系黑茶茶类中的一个品种， 创制于湖南省安化县江南一带，是安化的一个传统名茶，是以每卷(支)的茶叶净含量合老秤一千两而得名，因其外表的篾篓包装成花格状，故又名花卷茶。</p><p>千两茶的外观呈现出砖形，通常重量在1000克左右，因此得名“千两茶”。它的外观色泽深绿，茶叶质地紧实，香气浓郁。千两茶的口感醇厚，滋味浓烈，具有独特的陈香和甘甜的味道。此外，千两茶还富含丰富的茶多酚和咖啡碱等营养物质，具有一定的保健功效，如提神醒脑、消除疲劳等。</p><p>千两茶在中国茶文化中占有重要地位，被广泛饮用和收藏。它不仅作为一种传统的饮品，还被用作礼品赠送或商务交流的重要礼物。</p>':'<p>千两茶系黑茶茶类中的一个品种， 创制于湖南省安化县江南一带，是安化的一个传统名茶，是以每卷(支)的茶叶净含量合老秤一千两而得名，因其外表的篾篓包装成花格状，故又名花卷茶。</p><p>千两茶的外观呈现出砖形，通常重量在1000克左右，因此得名“千两茶”。它的外观色泽深绿，茶叶质地紧实，香气浓郁。千两茶的口感醇厚，滋味浓烈，具有独特的陈香和甘甜的味道。此外，千两茶还富含丰富的茶多酚和咖啡碱等营养物质，具有一定的保健功效，如提神醒脑、消除疲劳等。</p><p>千两茶在中国茶文化中占有重要地位，被广泛饮用和收藏。它不仅作为一种传统的饮品，还被用作礼品赠送或商务交流的重要礼物。</p>',

   '茶的类别及品种':'茶的类别及品种',
   '外圈环显示茶的类别及该类别下茶的品种。颜色代表茶的类别：绿茶、白茶、黄茶、乌龙茶、红茶、黑茶。':'外圈环显示茶的类别及该类别下茶的品种。颜色代表茶的类别：绿茶、白茶、黄茶、乌龙茶、红茶、黑茶。',

   '茶省':'茶省',
   '内圈表示产茶省份，点击省份显示省份与茶之间的对应关系与产茶地图。圆环的角度越大，说明该省份产茶越多':'内圈表示产茶省份，点击省份显示省份与茶之间的对应关系与产茶地图。圆环的角度越大，说明该省份产茶越多',

   '茶的详细信息':'茶的详细信息',
   '鼠标点击外环的茶对应的小卡片可以查看该茶的详细信息。':'鼠标点击外环的茶对应的小卡片可以查看该茶的详细信息。',

   '产茶地图':'产茶地图',
   '点击外环的小卡片后展示，显示该省份产地点位等情况。':'点击外环的小卡片后展示，显示该省份产地点位等情况。',

   '导航栏':'导航栏',
   '使用导航栏可以进行页面之间的快速跳转。':'使用导航栏可以进行页面之间的快速跳转。',

   '导航项':'导航项',
   '点击导航项可以直接实现页面的跳转。':'点击导航项可以直接实现页面的跳转。',

   "上一步": "上一步",
   "下一步": "下一步",
   "跳过": "跳过",
   "完成": "完成",

   "切换语言":"切换语言",
   "聊天":"聊天",


   "茶叶的发酵实际上是茶叶细胞中茶多酚和多酚氧化酶相互作用的过程。发酵的程度不同，影响了茶叶的颜色、味道、香气和汤色等特征，从而将茶叶分为六大类。":"茶叶的发酵实际上是茶叶细胞中茶多酚和多酚氧化酶相互作用的过程。发酵的程度不同，影响了茶叶的颜色、味道、香气和汤色等特征，从而将茶叶分为六大类。",
   '低':'低',
   '高':'高',
   "绿茶发酵":"绿茶发酵",
   "白茶发酵":"白茶发酵",
   "黄茶发酵":"黄茶发酵",
   "乌龙茶发酵":"乌龙茶发酵",
   "红茶发酵":"红茶发酵",
   "黑茶发酵":"黑茶发酵",

   "采青":"采青",
   "萎凋":"萎凋",
   "摇青":"摇青",
   "杀青":"杀青",
   "揉捻":"揉捻",
   "氧化发酵":"氧化发酵",
   "晒青":"晒青",
   "渥堆":"渥堆",
   "晾干":"晾干",
   "闷黄":"闷黄",
   "烘青":"烘青",
   "干燥":"干燥",

   "收集茶叶原料":"收集茶叶原料",
   "失水软化叶片":"失水软化叶片",
   "保留颜色香气":"保留颜色香气",
   "形成特定形状":"形成特定形状",
   "自然晾干茶叶":"自然晾干茶叶",
   "完全除去水分":"完全除去水分",
   "高温稳定品质":"高温稳定品质",
   "自然风干茶叶":"自然风干茶叶",
   "破碎叶缘释汁液":"破碎叶缘释汁液",
   "空气中发酵茶叶":"空气中发酵茶叶",
   "在春季或早夏，嫩叶最为嫩绿，因此是最佳采摘时机。通常选择手工采摘，保证采摘到最嫩的茶叶。":"在春季或早夏，嫩叶最为嫩绿，因此是最佳采摘时机。通常选择手工采摘，保证采摘到最嫩的茶叶。",
   "将采摘的茶叶经过高温处理，阻止叶中酶的活动，保留茶叶的颜色、香气和营养成分。":"将采摘的茶叶经过高温处理，阻止叶中酶的活动，保留茶叶的颜色、香气和营养成分。",
   "经过杀青后，茶叶进行揉捻，帮助茶叶保持特定的形状，同时有助于释放茶叶的香气。":"经过杀青后，茶叶进行揉捻，帮助茶叶保持特定的形状，同时有助于释放茶叶的香气。",
   "揉捻后的茶叶会经过烘干处理，高温稳定茶叶的品质，确保茶叶不会变质。":"揉捻后的茶叶会经过烘干处理，高温稳定茶叶的品质，确保茶叶不会变质。",
   "最后，茶叶会进行干燥处理，以确保茶叶的水分达到适当的水平，便于长期储存，并保持茶叶的品质和口感。":"最后，茶叶会进行干燥处理，以确保茶叶的水分达到适当的水平，便于长期储存，并保持茶叶的品质和口感。",

   "与其他茶类制作过程相似，白茶的制作也始于采摘。采摘白茶时，通常选择嫩绿的茶芽和叶子作为原料。":"与其他茶类制作过程相似，白茶的制作也始于采摘。采摘白茶时，通常选择嫩绿的茶芽和叶子作为原料。",
   "采摘后的茶叶会进行晾晒处理。这个步骤不涉及高温处理或杀青，而是让茶叶自然地在阳光下或通风良好的环境中晾干，使其逐渐失去水分。":"采摘后的茶叶会进行晾晒处理。这个步骤不涉及高温处理或杀青，而是让茶叶自然地在阳光下或通风良好的环境中晾干，使其逐渐失去水分。",
   "在晾干之后，茶叶经过最终的干燥阶段。这个步骤有助于确保茶叶的水分含量达到适当的水平，以便储存和保持其品质。":"在晾干之后，茶叶经过最终的干燥阶段。这个步骤有助于确保茶叶的水分含量达到适当的水平，以便储存和保持其品质。",

   "和其他茶类一样，黄茶的制作始于采摘。采摘时通常选择嫩绿的茶芽和叶子作为原料。":"和其他茶类一样，黄茶的制作始于采摘。采摘时通常选择嫩绿的茶芽和叶子作为原料。",
   "采摘的茶叶会经历一个特殊的萎凋过程，与其他茶类不同，黄茶的萎凋阶段时间较长，让茶叶逐渐失去水分并变软。":"采摘的茶叶会经历一个特殊的萎凋过程，与其他茶类不同，黄茶的萎凋阶段时间较长，让茶叶逐渐失去水分并变软。",
   "经过萎凋后，茶叶会进行杀青处理，这个阶段的杀青相对柔和，不像绿茶那样高温处理。杀青有助于保留茶叶的颜色和香气。":"经过萎凋后，茶叶会进行杀青处理，这个阶段的杀青相对柔和，不像绿茶那样高温处理。杀青有助于保留茶叶的颜色和香气。",
   "杀青后，茶叶经过烘焙处理，这个步骤有助于进一步固定茶叶的香气和品质。":"杀青后，茶叶经过烘焙处理，这个步骤有助于进一步固定茶叶的香气和品质。",
   "最后，茶叶会进行处理，确保茶叶中的水分达到适当的水平，以便长期储存，并保持其品质和口感。":"最后，茶叶会进行处理，确保茶叶中的水分达到适当的水平，以便长期储存，并保持其品质和口感。",

   "茶叶制作始于采摘。在制作时，通常选择嫩绿的茶芽和嫩叶作为原料。":"茶叶制作始于采摘。在制作时，通常选择嫩绿的茶芽和嫩叶作为原料。",
   "在采摘后，茶叶经过摇晃或轻轻滚动的过程，这有助于破碎叶缘并释放汁液。":"在采摘后，茶叶经过摇晃或轻轻滚动的过程，这有助于破碎叶缘并释放汁液。",
   "接下来的步骤是进行杀青，阻止茶叶发酵并保留茶叶的颜色和香气。这个步骤通常涉及高温处理。":"接下来的步骤是进行杀青，阻止茶叶发酵并保留茶叶的颜色和香气。这个步骤通常涉及高温处理。",
   "杀青后的茶叶会进行揉捻，这有助于形成茶叶特定的形状并释放茶叶的香气。":"杀青后的茶叶会进行揉捻，这有助于形成茶叶特定的形状并释放茶叶的香气。",
   "最后，茶叶会进行干燥处理，确保茶叶中的水分达到适当的水平，便于长期储存，并保持茶叶的品质和口感。":"最后，茶叶会进行干燥处理，确保茶叶中的水分达到适当的水平，便于长期储存，并保持茶叶的品质和口感。",

   "茶叶制作始于采摘。通常会选择嫩绿的茶芽和嫩叶作为制作红茶的原料。":"茶叶制作始于采摘。通常会选择嫩绿的茶芽和嫩叶作为制作红茶的原料。",
   "采摘后的茶叶经历萎凋过程，让茶叶逐渐失去水分并变软。这个过程有助于茶叶中化学成分的改变。":"采摘后的茶叶经历萎凋过程，让茶叶逐渐失去水分并变软。这个过程有助于茶叶中化学成分的改变。",
   "茶叶进行揉捻，帮助释放茶叶内部的汁液，形成特定的形状。":"茶叶进行揉捻，帮助释放茶叶内部的汁液，形成特定的形状。",
   "接下来的关键步骤是氧化发酵。茶叶被散放在适当的环境中，让其在空气中发酵，氧化过程赋予了红茶独特的色泽和口感。":"接下来的关键步骤是氧化发酵。茶叶被散放在适当的环境中，让其在空气中发酵，氧化过程赋予了红茶独特的色泽和口感。",
   "最后，茶叶会进行干燥处理，以确保茶叶的水分达到适当的水平，便于长期储存，并保持其品质和口感。":"最后，茶叶会进行干燥处理，以确保茶叶的水分达到适当的水平，便于长期储存，并保持其品质和口感。",

   "黑茶的制作始于采摘。通常会选择嫩绿的茶芽和嫩叶作为制作黑茶的原料。":"黑茶的制作始于采摘。通常会选择嫩绿的茶芽和嫩叶作为制作黑茶的原料。",
   "采摘后的茶叶经历萎凋过程，让茶叶逐渐失去水分并变软。这个过程有助于茶叶中化学成分的改变。":"采摘后的茶叶经历萎凋过程，让茶叶逐渐失去水分并变软。这个过程有助于茶叶中化学成分的改变。",
   "接下来的步骤是进行杀青处理，这个过程相对较温和，有助于保留茶叶的颜色和香气。":"接下来的步骤是进行杀青处理，这个过程相对较温和，有助于保留茶叶的颜色和香气。",
   "经过杀青后，茶叶会进行揉捻，这有助于形成茶叶特定的形状并释放茶叶的香气。":"经过杀青后，茶叶会进行揉捻，这有助于形成茶叶特定的形状并释放茶叶的香气。",
   "黑茶制作的独特之处在于晒青这个步骤。茶叶会被摊开并在适当的环境中暴晒，让茶叶进一步发酵和氧化。":"黑茶制作的独特之处在于晒青这个步骤。茶叶会被摊开并在适当的环境中暴晒，让茶叶进一步发酵和氧化。",
   "最后，茶叶会进行干燥处理，以确保茶叶的水分达到适当的水平，便于长期储存，并保持其品质和口感。":"最后，茶叶会进行干燥处理，以确保茶叶的水分达到适当的水平，便于长期储存，并保持其品质和口感。",
    "茶叶，其实是一年四季皆可采摘制作的。":"茶叶，其实是一年四季皆可采摘制作的。",
    "主要的采摘季节有春、夏、秋这三个季节，冬季主要预留给茶树恢复调养。":"主要的采摘季节有春、夏、秋这三个季节，冬季主要预留给茶树恢复调养。",
    "其中，3-5月采制的为春茶；5-7月采制的为夏茶；8-10月采制的为秋茶；10月下旬采制的为冬茶。由于不同的茶类，对茶叶原料的嫩度要求不同，因此采摘时间也会有所区别。相对嫩的茶叶，多为春茶、秋茶；粗大的茶叶，多为夏茶、秋茶。":"其中，3-5月采制的为春茶；5-7月采制的为夏茶；8-10月采制的为秋茶；10月下旬采制的为冬茶。由于不同的茶类，对茶叶原料的嫩度要求不同，因此采摘时间也会有所区别。相对嫩的茶叶，多为春茶、秋茶；粗大的茶叶，多为夏茶、秋茶。",
    "开始采摘时间":"开始采摘时间",
    "结束采摘时间":"结束采摘时间",
    "提示":"提示",
    "由于该省份不是主要产茶省份，暂无数据！":"由于该省份不是主要产茶省份，暂无数据！",

    "中国茶叶产地":"中国茶叶产地",
    "绿茶产地":"绿茶产地",
    "绿茶在中国有许多主要产地，其中之一是浙江省的西湖龙井茶产区。西湖龙井茶产区位于浙江省杭州市西湖区，是中国绿茶的代表产地之一。这里的茶园环境优美，地理位置独特，享有得天独厚的自然条件。除此之外，西湖龙井茶产区还因其悠久的茶史和精湛的制茶工艺而闻名。当地的茶农们世代相传着制茶的技艺，他们手工采摘、炒制的技艺独具匠心，使得西湖龙井茶具有独特的清香和口感，倍受国内外茶客的喜爱。这种传统的制茶工艺也被列为中国非物质文化遗产，体现了中国茶文化的深厚底蕴和博大精深。":"绿茶在中国有许多主要产地，其中之一是浙江省的西湖龙井茶产区。西湖龙井茶产区位于浙江省杭州市西湖区，是中国绿茶的代表产地之一。这里的茶园环境优美，地理位置独特，享有得天独厚的自然条件。除此之外，西湖龙井茶产区还因其悠久的茶史和精湛的制茶工艺而闻名。当地的茶农们世代相传着制茶的技艺，他们手工采摘、炒制的技艺独具匠心，使得西湖龙井茶具有独特的清香和口感，倍受国内外茶客的喜爱。这种传统的制茶工艺也被列为中国非物质文化遗产，体现了中国茶文化的深厚底蕴和博大精深。",
    "白茶产地":"白茶产地",
    "福建省福州市和南平市以及江西省赣州市等地，是中国白茶的主要产区。白茶以嫩芽为原料，制作工艺简单，历史悠久，被誉为“茶中贵妃”。福建省福州市的白茶种植历史悠久，其产的白茶具有独特的香气和口感，是著名的白茶产地之一。这些地区的白茶还因其丰富的品种而备受推崇。白茶的制作工艺简单，但由于生长环境和采摘工艺的不同，不同地区的白茶呈现出各具特色的口感和香气。福建省福州市的白茶种植历史悠久，其主要品种包括白牡丹、白毫银针等，每一种都有其独特的风味和品质特点。这些品种不仅受到国内茶客的喜爱，也在国际茶市场上享有盛名，成为中国茶文化的重要代表之一。":"福建省福州市和南平市以及江西省赣州市等地，是中国白茶的主要产区。白茶以嫩芽为原料，制作工艺简单，历史悠久，被誉为“茶中贵妃”。福建省福州市的白茶种植历史悠久，其产的白茶具有独特的香气和口感，是著名的白茶产地之一。这些地区的白茶还因其丰富的品种而备受推崇。白茶的制作工艺简单，但由于生长环境和采摘工艺的不同，不同地区的白茶呈现出各具特色的口感和香气。福建省福州市的白茶种植历史悠久，其主要品种包括白牡丹、白毫银针等，每一种都有其独特的风味和品质特点。这些品种不仅受到国内茶客的喜爱，也在国际茶市场上享有盛名，成为中国茶文化的重要代表之一。",
    "黄茶产地":"黄茶产地",
    "安徽省的歙县、黄山市、屯溪市等地是黄茶的主要产区之一。黄茶制作工艺独特，包括晾青、杀青、拼配、炒青等多个环节，其中以晾青最为特殊，是黄茶与其他茶类的显著区别。黄茶具有独特的香气和口感，被誉为“中华名茶”之一。这些地区的丰富降水量、充足的日照以及独特的土壤成分为黄茶的生长提供了良好的条件，使得所产的黄茶香气浓郁、口感鲜爽":"安徽省的歙县、黄山市、屯溪市等地是黄茶的主要产区之一。黄茶制作工艺独特，包括晾青、杀青、拼配、炒青等多个环节，其中以晾青最为特殊，是黄茶与其他茶类的显著区别。黄茶具有独特的香气和口感，被誉为“中华名茶”之一。这些地区的丰富降水量、充足的日照以及独特的土壤成分为黄茶的生长提供了良好的条件，使得所产的黄茶香气浓郁、口感鲜爽",
    "乌龙茶产地":"乌龙茶产地",
    "福建省的武夷山、安溪、南安等地是乌龙茶的著名产区之一。乌龙茶是一种半发酵茶，制作工艺介于绿茶和红茶之间，具有独特的清香和鲜爽口感。乌龙茶口感鲜爽，香气芬芳，被誉为“茶中王者”，深受茶叶爱好者的喜爱。这些地区地形多样，气候适宜，海拔高低起伏，雨量充沛，土壤肥沃，为乌龙茶的生长提供了得天独厚的条件":"福建省的武夷山、安溪、南安等地是乌龙茶的著名产区之一。乌龙茶是一种半发酵茶，制作工艺介于绿茶和红茶之间，具有独特的清香和鲜爽口感。乌龙茶口感鲜爽，香气芬芳，被誉为“茶中王者”，深受茶叶爱好者的喜爱。这些地区地形多样，气候适宜，海拔高低起伏，雨量充沛，土壤肥沃，为乌龙茶的生长提供了得天独厚的条件",
    "红茶产地":"红茶产地",
    "红茶主要产地包括福建、云南、湖南、江西等地。福建省的红茶制作工艺精湛，尤以福州、武夷山、安溪、南平等地最为著名。云南省的滇红茶以其丰富的花香和鲜爽的口感而闻名，湖南的祁阳红茶具有独特的甜香和鲜爽的口感，江西的红茶以其浓厚的香气和醇和的口感而受到广泛欢迎。福建、云南、湖南、江西等地区的多样地形、丰富降水和充足日照，为茶树的生长提供了理想的生态环境":"红茶主要产地包括福建、云南、湖南、江西等地。福建省的红茶制作工艺精湛，尤以福州、武夷山、安溪、南平等地最为著名。云南省的滇红茶以其丰富的花香和鲜爽的口感而闻名，湖南的祁阳红茶具有独特的甜香和鲜爽的口感，江西的红茶以其浓厚的香气和醇和的口感而受到广泛欢迎。福建、云南、湖南、江西等地区的多样地形、丰富降水和充足日照，为茶树的生长提供了理想的生态环境",
    "黑茶产地":"黑茶产地",
    "云南省的普洱茶是最为著名的黑茶之一，其制作工艺历史悠久，具有独特的陈香和醇厚口感。广西的六堡茶和湖南的安化黑茶也是知名的黑茶品种，它们的口感丰富深邃，带有特有的陈香和木香味。黑茶的制作工艺独特，使得茶叶呈现出深红至黑褐色的色泽，香气独特，口感浓郁醇厚。云南省的普洱茶、广西的六堡茶和湖南的安化黑茶等地区，都位于中国南方，气候湿润，雨量充沛，阳光充足，这些条件有利于茶树的生长":"云南省的普洱茶是最为著名的黑茶之一，其制作工艺历史悠久，具有独特的陈香和醇厚口感。广西的六堡茶和湖南的安化黑茶也是知名的黑茶品种，它们的口感丰富深邃，带有特有的陈香和木香味。黑茶的制作工艺独特，使得茶叶呈现出深红至黑褐色的色泽，香气独特，口感浓郁醇厚。云南省的普洱茶、广西的六堡茶和湖南的安化黑茶等地区，都位于中国南方，气候湿润，雨量充沛，阳光充足，这些条件有利于茶树的生长",

    '由于该省份不是主要产茶省份，暂无数据！':'由于该省份不是主要产茶省份，暂无数据！',
    "主要产区种植面积":"主要产区种植面积",
    "点击省份查看省份种植面积变化折线图。":"点击省份查看省份种植面积变化折线图。",
    "点击右上角的茶类别切换视图":"点击右上角的茶类别切换视图",

    '广东省近几年产地（万亩）':'广东省近几年产地（万亩）',
    "安徽省近几年产地（万亩）":"安徽省近几年产地（万亩）",
    "湖南省近几年产地（万亩）":"湖南省近几年产地（万亩）",
    "浙江省近几年产地（万亩）":"浙江省近几年产地（万亩）",
    "贵州省近几年产地（万亩）":"贵州省近几年产地（万亩）",
    "云南省近几年产地（万亩）":"云南省近几年产地（万亩）",
    "广西省近几年产地（万亩）":"广西省近几年产地（万亩）",
    "江苏省近几年产地（万亩）":"江苏省近几年产地（万亩）",
    "四川省近几年产地（万亩）":"四川省近几年产地（万亩）",
    "福建省近几年产地（万亩）":"福建省近几年产地（万亩）",
    "陕西省近几年产地（万亩）":"陕西省近几年产地（万亩）",
    "湖北省近几年产地（万亩）":"湖北省近几年产地（万亩）",
    "江西省近几年产地（万亩）":"江西省近几年产地（万亩）",
    "山东省近几年产地（万亩）":"山东省近几年产地（万亩）",
    "河南省近几年产地（万亩）":"河南省近几年产地（万亩）",
    "海南省近几年产地（万亩）":"海南省近几年产地（万亩）",
    "重庆近几年产地（万亩）":"重庆近几年产地（万亩）",
    "甘肃省近几年产地（万亩）":"甘肃省近几年产地（万亩）",


    "重庆":"重庆",
    "四川":"四川",

    "北京":"北京",
    "天津":"天津",
    "河北":"河北",
    "山西":"山西",
    "内蒙古":"内蒙古",
    "辽宁":"辽宁",
    "吉林":"吉林",
    "黑龙江":"黑龙江",
    "上海":"上海",
    "西藏":"西藏",
    "青海":"青海",
    "宁夏":"宁夏",
    "新疆":"新疆",
    "台湾":"台湾",
    "南海诸岛":"南海诸岛",

    "河南":"河南",
    "贵州":"贵州",
    "江西":"江西",
    "安徽":"安徽",
    "浙江":"浙江",
    "江苏":"江苏",
    "陕西":"陕西",
    "湖南":"湖南",
    "湖北":"湖北",
    "广西":"广西",
    "福建":"福建",
    "山东":"山东",
    "海南":"海南",
    "甘肃":"甘肃",
    "湖北":"湖北",
    "云南":"云南",
    "广东":"广东",

    "2022年":"2022",
    "2021年":"2021",
    "2020年":"2020",
    "2019年":"2019",
    "2018年":"2018",

    "平均数":"平均数",
    "中位数":"中位数",
    "方差":"方差",

    "鉴别茶叶品质好坏，主要采用感官审评的方法，对茶叶的外形与内质进行评判。具体步骤主要分为闻、观、饮三步。":"鉴别茶叶品质好坏，主要采用感官审评的方法，对茶叶的外形与内质进行评判。具体步骤主要分为闻、观、饮三步。",
    "评茶方式":"评茶方式",
    "评茶是一种传统的中国茶文化活动，通常由茶艺师或茶叶爱好者主持。在评茶过程中，参与者会品尝不同种类的茶叶，并对其外形、香气、滋味、汤色等方面进行评价。": "评茶是一种传统的中国茶文化活动，通常由茶艺师或茶叶爱好者主持。在评茶过程中，参与者会品尝不同种类的茶叶，并对其外形、香气、滋味、汤色等方面进行评价。",
    "闻":"闻",
    "将茶汤倒入茶海，闻盖碗中茶叶香气，评鉴茶叶香气和杂味。":"将茶汤倒入茶海，闻盖碗中茶叶香气，评鉴茶叶香气和杂味。",
    "观":"观",
    "从玻璃茶海观茶汤色色泽、清亮度、有无沉淀、有无漂浮。": "从玻璃茶海观茶汤色色泽、清亮度、有无沉淀、有无漂浮。",
    "饮":"饮",
    "当茶汤温度降至45℃以下，取10ml-15ml含入口中，让茶汤接触口腔所有部位，之后缓慢吞下。":"当茶汤温度降至45℃以下，取10ml-15ml含入口中，让茶汤接触口腔所有部位，之后缓慢吞下。",
    "净、整、色":"净、整、色",
    "看干茶":"看干茶",
    "看干茶的色泽、质地、匀齐度、紧结度、显毫状况。":"看干茶的色泽、质地、匀齐度、紧结度、显毫状况。",
    "看茶汤色泽":"看茶汤色泽",
    "观茶茶汤的色泽，主要看鲜亮度、透析度、有无杂质、有无浑浊。":"观茶茶汤的色泽，主要看鲜亮度、透析度、有无杂质、有无浑浊。",
    "看茶底":"看茶底",
    "看展开后茶叶的细嫩、匀齐以及完整度，还要看是否存有焦斑、红筋、红梗等现象。":"看展开后茶叶的细嫩、匀齐以及完整度，还要看是否存有焦斑、红筋、红梗等现象。",
    "干、热、冷":"干、热、冷",
    "干闻（干茶）":"干闻（干茶）",
    "该有的茶味：香味、纯净度：不该有的茶味：杂味、陈味、霉味、沾染的其他味道。":"该有的茶味：香味、纯净度：不该有的茶味：杂味、陈味、霉味、沾染的其他味道。",
    "热闻（冲泡后）":"热闻（冲泡后）",
    "在茶温度较高时闻香。闻香形式：盖碗缝隙、盖香、茶香、公道杯香。":"在茶温度较高时闻香。闻香形式：盖碗缝隙、盖香、茶香、公道杯香。",
    "冷闻（器皿及茶底）":"冷闻（器皿及茶底）",
    "温度降低后再闻茶盖或杯底留香，这时可闻到在高温时，因茶叶芬香物大量挥发而掩盖的其他香味。":"温度降低后再闻茶盖或杯底留香，这时可闻到在高温时，因茶叶芬香物大量挥发而掩盖的其他香味。",
    "甘、润、韵。品茶方法：将茶汤含在嘴里，像含着一朵鲜花一样慢慢感受，细细品味，吞下去时还要注意感受茶汤过喉时是否爽滑。":"甘、润、韵。品茶方法：将茶汤含在嘴里，像含着一朵鲜花一样慢慢感受，细细品味，吞下去时还要注意感受茶汤过喉时是否爽滑。",
    "滋味":"滋味",
    "让茶汤在口腔内流动，与舌部充分接触，细品茶味是浓烈鲜爽、甜爽，还是苦涩、淡薄。":"让茶汤在口腔内流动，与舌部充分接触，细品茶味是浓烈鲜爽、甜爽，还是苦涩、淡薄",
    "甘醇度":"甘醇度",
    "厚：代表茶浸出物多，丰富、耐泡；细腻度、油润度：又厚又油润喝起来就不会烫刺喉咙。":"厚：代表茶浸出物多，丰富、耐泡；细腻度、油润度：又厚又油润喝起来就不会烫刺喉咙。",
    "回味":"回味",
    "当茶汤温度降至45℃以下，取10ml-15ml含入口中，让茶汤接触口腔所有部位，之后缓慢吞下。":"当茶汤温度降至45℃以下，取10ml-15ml含入口中，让茶汤接触口腔所有部位，之后缓慢吞下。",
    "清香":"清香",
    "见于鲜叶嫩度在一芽二、三叶，制茶及时正常的绿茶等。":"见于鲜叶嫩度在一芽二、三叶，制茶及时正常的绿茶等。",
    "青草香":"青草香",
    "野生茶具备的浓郁香味，用青草香来描述。":"野生茶具备的浓郁香味，用青草香来描述。",
    "花香":"花香",
    "各种类似鲜花的香气，按花香青甜的不同，分为青花香和甜花香两种。":"各种类似鲜花的香气，按花香青甜的不同，分为青花香和甜花香两种。",
    "板栗香":"板栗香",
    "似栗子炒熟时发出的香气。高山优质茶的香型。":"似栗子炒熟时发出的香气。高山优质茶的香型。",
    "兰香":"兰香",
    "幽然之香，清爽幽雅，是最珍贵的茶香。":"幽然之香，清爽幽雅，是最珍贵的茶香。",
    "水果香":"水果香",
    "类似各种水果香气，如雪梨香、佛手香、桔子香、李子香等等。":"类似各种水果香气，如雪梨香、佛手香、桔子香、李子香等等。",
    "蜜香":"蜜香",
    "2~5年的茶都会呈现出的香味，即经过发酵一段时间的生饼。":"2~5年的茶都会呈现出的香味，即经过发酵一段时间的生饼。",
    "火香":"火香",
    "茶叶在干燥时温度比较高，在精制时适度焙火而来。":"茶叶在干燥时温度比较高，在精制时适度焙火而来。",
    "檀香":"檀香",
    "青壮叶生茶在一定时间的高温存储和退仓后，茶汤所产生的特有香气。":"青壮叶生茶在一定时间的高温存储和退仓后，茶汤所产生的特有香气。",
    "药香":"药香",
    "在年份老的茶中出现的香味，与熬中药的药汤外形和口感都接近。":"在年份老的茶中出现的香味，与熬中药的药汤外形和口感都接近。",
    "荷香":"荷香",
    "茶叶经过适当的陈化后发酵，去掉青叶香后留下了淡淡的荷香。":"茶叶经过适当的陈化后发酵，去掉青叶香后留下了淡淡的荷香。",
    "参香":"参香",
    "木质化香气，陈年老茶居多。":"木质化香气，陈年老茶居多。",
    "枣香":"枣香",
    "老白茶具有的像红枣般的香气。":"老白茶具有的像红枣般的香气。",
    "菌花香":"菌花香",
    "部分有“金花”的黑茶特有的香气。":"部分有“金花”的黑茶特有的香气。",
    "日晒香":"日晒香",
    "白茶经过日晒产生的气味。":"白茶经过日晒产生的气味。",
    "麦香":"麦香",
    "经过麦香香精的注入或者与麦香干燥花朵混合加工而成的香气。":"经过麦香香精的注入或者与麦香干燥花朵混合加工而成的香气。",
    "由于茶汤中的茶多酚与空气接触会很快氧化，以致茶汤容易变色。因而要及时欣赏汤色，主要从色度、亮度、清浊度等方面，辨别茶汤颜色深浅、正常与否、茶汤暗明、清澈或浑浊程度。":"由于茶汤中的茶多酚与空气接触会很快氧化，以致茶汤容易变色。因而要及时欣赏汤色，主要从色度、亮度、清浊度等方面，辨别茶汤颜色深浅、正常与否、茶汤暗明、清澈或浑浊程度。",

    "艳绿":"艳绿",
    "绿黄":"绿黄",
    "黄绿":"黄绿",
    "浅黄":"浅黄",
    "金黄":"金黄",
    "橙黄":"橙黄",
    "橙红":"橙红",
    "红汤":"红汤",
    "凝乳":"凝乳",
    "明亮":"明亮",
    "浑浊":"浑浊",
    "昏暗":"昏暗",
    "“艳绿”所指的茶汤色泽，通常为清澈透明、明亮鲜艳的绿色，展现出茶叶新鲜、活力的特质，其色泽饱满生动，常被视为绿茶优质的象征之一。":"“艳绿”所指的茶汤色泽，通常为清澈透明、明亮鲜艳的绿色，展现出茶叶新鲜、活力的特质，其色泽饱满生动，常被视为绿茶优质的象征之一。",
    "“绿黄”茶汤色泽具有一定的绿色和黄色的混合特征，呈现出柔和明亮的外观，通常不如艳绿那样饱满明亮，而是更具有一种柔和平和的感觉。":"“绿黄”茶汤色泽具有一定的绿色和黄色的混合特征，呈现出柔和明亮的外观，通常不如艳绿那样饱满明亮，而是更具有一种柔和平和的感觉。",
    "“黄绿”茶汤色泽具有一定的黄色和绿色的混合特征，呈现出柔和、明亮、清澈的外观，通常不如艳绿那样饱满明亮，而是更具有一种柔和平和的感觉。":"“黄绿”茶汤色泽具有一定的黄色和绿色的混合特征，呈现出柔和、明亮、清澈的外观，通常不如艳绿那样饱满明亮，而是更具有一种柔和平和的感觉。",
    "“浅黄”茶汤色泽呈现出柔和的黄色调，清澈透明，通常具有一定的清淡感和平和感，是一种较为温和的茶汤颜色。":"“浅黄”茶汤色泽呈现出柔和的黄色调，清澈透明，通常具有一定的清淡感和平和感，是一种较为温和的茶汤颜色。",
    "“金黄”茶汤色泽呈现出鲜艳的金黄色调，色泽明亮而饱满，具有极高的透明度和光泽感，通常具有浓郁的香气和口感，是一种高档茶汤的典型特征。":"“金黄”茶汤色泽呈现出鲜艳的金黄色调，色泽明亮而饱满，具有极高的透明度和光泽感，通常具有浓郁的香气和口感，是一种高档茶汤的典型特征。",
    "“橙黄”茶汤色泽呈现出明显的橙色和黄色的混合特征，通常呈现出明亮而饱满的外观，色泽鲜艳，但不像金黄那样明亮，而是更倾向于橙色。":"“橙黄”茶汤色泽呈现出明显的橙色和黄色的混合特征，通常呈现出明亮而饱满的外观，色泽鲜艳，但不像金黄那样明亮，而是更倾向于橙色。",
    "“橙红”茶汤色泽呈现出明显的橙色和红色的混合特征，通常呈现出鲜艳而丰富的外观，色泽明亮，光泽度较高，是一种具有特殊风味的茶汤色泽。":"“橙红”茶汤色泽呈现出明显的橙色和红色的混合特征，通常呈现出鲜艳而丰富的外观，色泽明亮，光泽度较高，是一种具有特殊风味的茶汤色泽。",
    "“红汤”茶汤色泽呈现出明显的红色调，色泽鲜艳而丰富，具有浓烈的红色，香气浓郁，口感醇厚，是红茶特有的一种茶汤颜色，也是其独特风味的象征。":"“红汤”茶汤色泽呈现出明显的红色调，色泽鲜艳而丰富，具有浓烈的红色，香气浓郁，口感醇厚，是红茶特有的一种茶汤颜色，也是其独特风味的象征。",
    "“凝乳”茶汤色泽呈现出乳白色或者奶白色的特殊状态，具有非常低的透明度和浑浊感，散发出特殊的乳香或者奶香，是某些优质白茶或者普洱茶的特有特征之一，也是其独特风味的象征。":"“凝乳”茶汤色泽呈现出乳白色或者奶白色的特殊状态，具有非常低的透明度和浑浊感，散发出特殊的乳香或者奶香，是某些优质白茶或者普洱茶的特有特征之一，也是其独特风味的象征。",
    "“明亮”茶汤色泽呈现出清澈透明的状态，色泽鲜艳明亮，通透度高，没有任何混浊或浑浊的迹象，是优质茶汤的典型特征之一，也是其独特风味的象征。":"“明亮”茶汤色泽呈现出清澈透明的状态，色泽鲜艳明亮，通透度高，没有任何混浊或浑浊的迹象，是优质茶汤的典型特征之一，也是其独特风味的象征。",
    "“浑浊”茶汤色泽呈现出不清晰、不透明的状态，具有一定的混浊度，通常是茶汤中悬浮着茶叶碎屑、细小颗粒或者茶汤沉淀物所致，影响了茶汤的透明度和口感，通常不是优质茶汤的特征。":"“浑浊”茶汤色泽呈现出不清晰、不透明的状态，具有一定的混浊度，通常是茶汤中悬浮着茶叶碎屑、细小颗粒或者茶汤沉淀物所致，影响了茶汤的透明度和口感，通常不是优质茶汤的特征。",
    "“昏暗”茶汤色泽呈现出暗淡、不明亮的状态，颜色偏暗，缺乏光泽和活力，是一种不理想的茶汤状态，通常不符合优质茶汤的特征。":"“昏暗”茶汤色泽呈现出暗淡、不明亮的状态，颜色偏暗，缺乏光泽和活力，是一种不理想的茶汤状态，通常不符合优质茶汤的特征。",

    "右侧桑基图展示了茶种各成分与滋味和味觉感受的对应关系。":"右侧桑基图展示了茶种各成分与滋味和味觉感受的对应关系。",
    "化合物种类":"化合物种类",
    "茶中成味成分":"茶中成味成分",
    "茶的滋味":"茶的滋味",
    "味觉感受":"味觉感受",
    "茶叶滋味是茶叶化学组成部分含量和人的感官对它的综合反应。茶叶有甜、酸、苦、鲜、涩等多种滋味。鲜味主要成分是多种氨基酸，氨基酸鲜中带甜，有的鲜中带酸。涩的主要特质是多酚类化合物。甜味物质主要有部分氨基酸和可溶性糖。苦味物质主要有咖啡碱、花青素、茶叶皂素。酸味物质主要是多种有机酸。":"茶叶滋味是茶叶化学组成部分含量和人的感官对它的综合反应。茶叶有甜、酸、苦、鲜、涩等多种滋味。鲜味主要成分是多种氨基酸，氨基酸鲜中带甜，有的鲜中带酸。涩的主要特质是多酚类化合物。甜味物质主要有部分氨基酸和可溶性糖。苦味物质主要有咖啡碱、花青素、茶叶皂素。酸味物质主要是多种有机酸。",

    "糖类":"糖类",
    "氨基酸":"氨基酸",
    "嘌呤碱":"嘌呤碱",
    "酚性物及其氧化物":"酚性物及其氧化物",
    "有机酸类":"有机酸类",
    "茶皂素":"茶皂素",
    "糖":"糖",
    "成味成分":"成味成分",
    "甘氨酸":"甘氨酸",
    "丙氨酸":"丙氨酸",
    "氨酸":"氨酸",
    "茶红素":"茶红素",
    "氨基酸类":"氨基酸类",
    "茶氨酸":"茶氨酸",
    "咖啡碱":"咖啡碱",
    "茶黄素":"茶黄素",
    "表儿茶素":"表儿茶素",
    "没食子儿茶素":"没食子儿茶素",
    "精氨酸":"精氨酸",
    "酚性酸儿茶素类":"酚性酸儿茶素类",
    "酯型儿茶素黄酮类":"酯型儿茶素黄酮类",
    "花表素":"花表素",
    "谷氨酸":"谷氨酸",
    "谷氨酰胺":"谷氨酰胺",
    "天冬氨酸":"天冬氨酸",
    "天冬氨酰胺":"天冬氨酰胺",
    "没食子酸":"没食子酸",
    "有机酸":"有机酸",
    "抗坏血酸":"抗坏血酸",
    "茶皂素类":"茶皂素类",
    "果胶素":"果胶素",
    "茶褐素":"茶褐素",
    "甜":"甜",
    "鲜甜":"鲜甜",
    "鲜爽甜":"鲜爽甜",
    "爽":"爽",
    "涩":"涩",
    "甜苦":"甜苦",
    "苦涩":"苦涩",
    "苦":"苦",
    "鲜甜酸":"鲜甜酸",
    "酸":"酸",
    "辛辣苦":"辛辣苦",
    "厚":"厚",
    "淡":"淡",
    "甜味":"甜味",
    "鲜味":"鲜味",
    "苦味":"苦味",
    "酸味":"酸味",
    "辣味":"辣味",
    "甜苦味":"甜苦味",
    "氨花表素基酸":"氨花表素基酸",
    "味觉":"味觉",
    "空":"空",

    "茉莉奶绿":"茉莉奶绿",
    "七窖茉莉香气馥郁端正，制成奶茶清甜怡人，浓郁奶香和茉莉花香经唇入喉，淡雅香气经久留存。":"七窖茉莉香气馥郁端正，制成奶茶清甜怡人，浓郁奶香和茉莉花香经唇入喉，淡雅香气经久留存。",
    "铁观音奶冻":"铁观音奶冻",
    "铁观音自带清雅兰香，搭配嫩滑奶冻，带来清爽又兼具浓郁奶香的丰富滋味。":"铁观音自带清雅兰香，搭配嫩滑奶冻，带来清爽又兼具浓郁奶香的丰富滋味。",
    "黄金椰椰乌龙":"黄金椰椰乌龙",
    "岩韵奇兰奶茶底蕴含绵远花香与豆香，入喉茶味香醇，加入Q弹椰果为茶香增添了无限玩味。":"岩韵奇兰奶茶底蕴含绵远花香与豆香，入喉茶味香醇，加入Q弹椰果为茶香增添了无限玩味。",
    "桂花酒酿奶绿":"桂花酒酿奶绿",
    "精选一年一季的优质五常糯米搭配桂林金桂，酿出微醺甜润，融入七窖茉莉茶底，口感更轻盈。":"精选一年一季的优质五常糯米搭配桂林金桂，酿出微醺甜润，融入七窖茉莉茶底，口感更轻盈。",
    "芝芝绿妍茶后":"芝芝绿妍茶后",
    "2012年首创第一杯芝士茶。定制绿茶底，融入真牛乳。":"2012年首创第一杯芝士茶。定制绿茶底，融入真牛乳。",
    "青稞牛乳茶":"青稞牛乳茶",
    "经典嫣红牛乳茶加入软糯有嚼劲的青稞，入口奶香、茶香醇醇鲜明，还带有淡淡自然青稞麦香。":"经典嫣红牛乳茶加入软糯有嚼劲的青稞，入口奶香、茶香醇醇鲜明，还带有淡淡自然青稞麦香。",
    "超清爽柠打绿":"超清爽柠打绿",
    "优选新鲜柠檬，每日鲜切暴打，融合甄选茶园定制绿茶汤，酸甜沁爽。":"优选新鲜柠檬，每日鲜切暴打，融合甄选茶园定制绿茶汤，酸甜沁爽。",
    "青提柠绿茶":"青提柠绿茶",
    "优选阳光玫瑰青提，颗颗精细去皮，加入暴打新鲜柠檬，融合绿茶底。":"优选阳光玫瑰青提，颗颗精细去皮，加入暴打新鲜柠檬，融合绿茶底。",
    "米布丁珍珠大红袍":"米布丁珍珠大红袍",
    "大师定制武夷山大红袍，13道工序传承东方岩韵，花香焙火香浑然天成。":"大师定制武夷山大红袍，13道工序传承东方岩韵，花香焙火香浑然天成。",
    "碧螺知春拿铁":"碧螺知春拿铁",
    "优选碧螺知春茶底，呈现花香蜜韵。":"优选碧螺知春茶底，呈现花香蜜韵。",
    "茉莉海盐拿铁":"茉莉海盐拿铁",
    "源自广西横州双瓣茉莉，六窨一提工艺，香气升级。":"源自广西横州双瓣茉莉，六窨一提工艺，香气升级。",
    "葡萄碎玉":"葡萄碎玉",
    "铁观音遇上当季葡萄，王者相逢，清甜顺滑的茶香融入葡萄的鲜甜可口。":"铁观音遇上当季葡萄，王者相逢，清甜顺滑的茶香融入葡萄的鲜甜可口。",

    "截至目前，已确认存在700多种茶叶芳香物质，但其核心成分仅约数十种。下表列出了一些主要成分以供参考。":"截至目前，已确认存在700多种茶叶芳香物质，但其核心成分仅约数十种。下表列出了一些主要成分以供参考。",
    "普遍来说，发酵程度轻、受热程度低的茶叶，其香气特性的沸点更低，香型更靠前；而发酵程度高、受热程度高的茶叶则相反，沸点更高，香型更靠后。另外，由于黑茶类的发酵原理独特，通常带有陈香的特性。":"普遍来说，发酵程度轻、受热程度低的茶叶，其香气特性的沸点更低，香型更靠前；而发酵程度高、受热程度高的茶叶则相反，沸点更高，香型更靠后。另外，由于黑茶类的发酵原理独特，通常带有陈香的特性。",

    "青草气":"青草气",
    "兰花香":"兰花香",
    "桂花香":"桂花香",
    "花果香":"花果香",
    "果香":"果香",
    "熟果香":"熟果香",
    "烤番薯香":"烤番薯香",
    "陈香":"陈香",

    "观察右图可知，各个省份的产量":"观察右图可知，各个省份的产量",
    "在2018—2022这个时间段内很接近，":"在2018—2022这个时间段内很接近，",
    "但各省份之间的产量却存在差异，":"但各省份之间的产量却存在差异，",
    "比如贵州、云南和福建的产量较多，":"比如贵州、云南和福建的产量较多，",
    "比如贵州、四川和福建的产值较多，":"比如贵州、四川和福建的产值较多，",
    "而江苏、陕西和广西省的产量较少。":"而江苏、陕西和广西省的产量较少。",
    "而江苏、广东和广西省的产值较少。":"而江苏、广东和广西省的产值较少。",
    "产量最高的福建省，在2022年达到":"产量最高的福建省，在2022年达到",
    "产值最高的贵州省，在2022年达到":"产值最高的贵州省，在2022年达到",
    "最高值459674.38吨，":"最高值459674.38吨，",
    "最高值498亿元，":"最高值498亿元，",
    "产量最少的江苏省，在2022年达到":"产量最少的江苏省，在2022年达到",
    "产值最少的江苏省，在2018年达到":"产值最少的江苏省，在2018年达到",
    "最低值10400吨。":"最低值10400吨。",
    "最低值26.22亿元。":"最低值26.22亿元。",
    "点击右上角的产量产值以实现数据切换~":"点击右上角的产量产值以实现数据切换~",
    "点击“茶园面积图”中的省份查看近几年的产量产销变化图。":"点击“茶园面积图”中的省份查看近几年的产量产销变化图。",

    "产量":"产量",
    "产值":"产值",
    "产量（吨）":"产量（吨）",
    "产值（亿元）":"产值（亿元）",

    "ZH":"ZH",
    "zh-CN":"zh-CN",
    "回忆茶史":"回忆茶史",
    "上古先秦":"上古先秦",
    "魏晋南北朝":"魏晋南北朝",
    "隋唐":"隋唐",
    "宋元":"宋元",
    "明":"明",
    "清":"清",
    "现代":"现代",
    "鼠标悬浮或点击图表散点查看详细历史事件；右侧选项卡可以切换图表~":"鼠标悬浮或点击图表散点查看详细历史事件；右侧选项卡可以切换图表~",

    "茶的最早发现": "茶的最早发现",
    "【茶的最早发现】陆羽《茶经》中说“茶之为饮，发乎神农氏”相传在公元前2700多年前的神农时代，神农为普济众生，常百草，采草药。有一天尝到一种草叶，使他口干舌燥，头晕目眩。于是背靠旁边的大树坐下休息，突然，一阵风过，传来一种清鲜香气，抬头望去树上绿叶葱茏。神农信手摘下一片放入只中咀嚼，味出苦，继而清香甘甜，食后更觉气味清香，舌底生津，精神爽朗，头晕目眩减轻，口干舌燥渐渐消失。神农遂名为“茶”，这便是茶的最早发现。": "【茶的最早发现】陆羽《茶经》中说“茶之为饮，发乎神农氏”相传在公元前2700多年前的神农时代，神农为普济众生，常百草，采草药。有一天尝到一种草叶，使他口干舌燥，头晕目眩。于是背靠旁边的大树坐下休息，突然，一阵风过，传来一种清鲜香气，抬头望去树上绿叶葱茏。神农信手摘下一片放入只中咀嚼，味出苦，继而清香甘甜，食后更觉气味清香，舌底生津，精神爽朗，头晕目眩减轻，口干舌燥渐渐消失。神农遂名为“茶”，这便是茶的最早发现。",
    "茶叶制作出现": "茶叶制作出现",
    "种植茶树，茶叶制作出现": "种植茶树，茶叶制作出现",
    "第一次贡茶和史上最早茶叶史料": "第一次贡茶和史上最早茶叶史料",
    "史上第一次贡茶和史上最早茶叶史料。公元前1046年，武王伐纣。周武王伐纣后，巴国以茶与其它珍贵产品纳贡，这是最早史料记载的史上第一次贡茶。同时，记载里巴国就有人工栽培茶树的茶园了。距今已3067年。": "史上第一次贡茶和史上最早茶叶史料。公元前1046年，武王伐纣。周武王伐纣后，巴国以茶与其它珍贵产品纳贡，这是最早史料记载的史上第一次贡茶。同时，记载里巴国就有人工栽培茶树的茶园了。距今已3067年。",
    "闻于鲁周公": "闻于鲁周公",
    "【闻于鲁周公】《茶经》记载，“茶之为饮，发乎神农氏，闻于鲁周公”说明周代既有茶出现": "【闻于鲁周公】《茶经》记载，“茶之为饮，发乎神农氏，闻于鲁周公”说明周代既有茶出现",
    "茶入中原": "茶入中原",
    "【茶入中原】春秋时代，茶叶用作祭品和蔬菜。随着大规模战争和人口迁徙，茶由巴蜀传入中原": "【茶入中原】春秋时代，茶叶用作祭品和蔬菜。随着大规模战争和人口迁徙，茶由巴蜀传入中原",
    "茶叶首次被文字记载": "茶叶首次被文字记载",
    "茶叶首次被文字记载": "茶叶首次被文字记载",
    "汉阳陵出土最早遗存茶叶实物": "汉阳陵出土最早遗存茶叶实物",
    "汉阳陵出土最早遗存茶叶实物，距今2150年之久。这是实证的汉代皇室御用茶叶，更是确证汉代皇室饮用茶芽。这意味着饮茶方式、制茶方式、储存方式的重要变革，对后世制茶饮茶有着极为深远的影响。": "汉阳陵出土最早遗存茶叶实物，距今2150年之久。这是实证的汉代皇室御用茶叶，更是确证汉代皇室饮用茶芽。这意味着饮茶方式、制茶方式、储存方式的重要变革，对后世制茶饮茶有着极为深远的影响。",
    "史上最早的茶叶向外传播": "史上最早的茶叶向外传播",
    "史上最早的茶叶向外传播。公元前119年，汉代张骞第二次出使中西亚，携带有茶叶。公元前108年，汉武帝征服朝鲜，将茶叶传入日本福冈。这是最早史料记载的茶叶向外传播行为，距今已2220年。": "史上最早的茶叶向外传播。公元前119年，汉代张骞第二次出使中西亚，携带有茶叶。公元前108年，汉武帝征服朝鲜，将茶叶传入日本福冈。这是最早史料记载的茶叶向外传播行为，距今已2220年。",
    "汉代武都茶叶市场": "汉代武都茶叶市场",
    "汉代武都茶叶市场：史上第一家茶叶交易市场。公元前59年，西汉蜀郡王褒与杨惠签署《僮约》购买仆人，并在契约中进行了超过一百项的工作约定。其中有两处涉及到茶：烹荼尽具、武都买荼。武都，在四川眉山地区，这是最早记载的史上第一家茶叶交易市场。距今已2079年。": "汉代武都茶叶市场：史上第一家茶叶交易市场。公元前59年，西汉蜀郡王褒与杨惠签署《僮约》购买仆人，并在契约中进行了超过一百项的工作约定。其中有两处涉及到茶：烹荼尽具、武都买荼。武都，在四川眉山地区，这是最早记载的史上第一家茶叶交易市场。距今已2079年。",
    "蜀之贡品": "蜀之贡品",
    "【蜀之贡品】武王伐纣以后，巴蜀为封国，文献记载就有茶叶为贡品的记载": "【蜀之贡品】武王伐纣以后，巴蜀为封国，文献记载就有茶叶为贡品的记载",
    "茶风初成": "茶风初成",
    "【茶风初成】汉朝，茶叶成为一种商品，供贵族饮用。初始的茶叶集散市场开始形成。“武阳卖茶”“烹茶尽具”——王褒《僮约》": "【茶风初成】汉朝，茶叶成为一种商品，供贵族饮用。初始的茶叶集散市场开始形成。“武阳卖茶”“烹茶尽具”——王褒《僮约》",
    "生煮羹饮": "生煮羹饮",
    "生煮羹饮。生煮羹饮类似现代的煮菜汤。或者理解成煮粥也可以。这是因为“火”在食物烹饪的发现，古人将茶用葱、姜、橘皮、花椒、桂皮等煮在一起进行食用": "生煮羹饮。生煮羹饮类似现代的煮菜汤。或者理解成煮粥也可以。这是因为“火”在食物烹饪的发现，古人将茶用葱、姜、橘皮、花椒、桂皮等煮在一起进行食用",
    "以茶代酒": "以茶代酒",
    "【以茶代酒】东吴最后的皇帝孙皓，嗜好饮酒，孙皓父亲的老师韦曜酒量不好，每次饮酒便悄悄让人把酒换成“荈”，让韦曜不至于难堪": "【以茶代酒】东吴最后的皇帝孙皓，嗜好饮酒，孙皓父亲的老师韦曜酒量不好，每次饮酒便悄悄让人把酒换成“荈”，让韦曜不至于难堪",
    "渐入民间": "渐入民间",
    "【渐入民间】两晋时期产茶渐多，及至晋后，茶叶的商品化发展到一定程度，逐级发展到民间。": "【渐入民间】两晋时期产茶渐多，及至晋后，茶叶的商品化发展到一定程度，逐级发展到民间。",
    "砖茶进贡最早记载": "砖茶进贡最早记载",
    "“蜀国晋原洞口漕，造茶为饼，二两，印龙风于上，饰以金箔，每八饼为一斤入贡，俗名砖茶”（砖茶进贡最早记载）。": "“蜀国晋原洞口漕，造茶为饼，二两，印龙风于上，饰以金箔，每八饼为一斤入贡，俗名砖茶”（砖茶进贡最早记载）。",
    "融入日常": "融入日常",
    "【融入日常】南地北朝江南区已将饮茶和喝酒、吃饭并列，成为日常生活必不可少的内容": "【融入日常】南地北朝江南区已将饮茶和喝酒、吃饭并列，成为日常生活必不可少的内容",
    "邛州砖茶": "邛州砖茶",
    "晋原于梁武帝时(503——519年）改称邛州，茶也改称“邛州砖茶”入贡，延续多年。": "晋原于梁武帝时(503——519年）改称邛州，茶也改称“邛州砖茶”入贡，延续多年。",
    "煎茶法": "煎茶法",
    "【煎茶法】唐代人品茶主要为煎茶，食用的是茶饼，该法为陆羽所创。": "【煎茶法】唐代人品茶主要为煎茶，食用的是茶饼，该法为陆羽所创。",
    "举国皆饮": "举国皆饮",
    "【举国皆饮】隋唐大运河的贯通，促使茶叶从南向北传播，达到了举国皆饮。“古人亦饮茶耳，但不如今大溺之善，始自中地，流于塞外”一《封氏闻见记》": "【举国皆饮】隋唐大运河的贯通，促使茶叶从南向北传播，达到了举国皆饮。“古人亦饮茶耳，但不如今大溺之善，始自中地，流于塞外”一《封氏闻见记》",
    "茶被广泛普及": "茶被广泛普及",
    "中国唐朝，茶被广泛普及成为了大众饮品并从王公贵族走入了平民百姓的日常生活。": "中国唐朝，茶被广泛普及成为了大众饮品并从王公贵族走入了平民百姓的日常生活。",
    "茶政": "茶政",
    "【茶政】唐德宗纳赵赞议，征召天下茶税，十取其一，茶叶成为茶政，受官方管控": "【茶政】唐德宗纳赵赞议，征召天下茶税，十取其一，茶叶成为茶政，受官方管控",
    "兴于唐": "兴于唐",
    "【兴于唐】顾渚山（今浙江长兴县）建立贡茶园，每年产“顾渚紫笋”，进贡皇朝。": "【兴于唐】顾渚山（今浙江长兴县）建立贡茶园，每年产“顾渚紫笋”，进贡皇朝。",
    "茶马贸易": "茶马贸易",
    "【茶马贸易】茶开始作为商品，与游牧民族交换马匹，边境贸易逐渐繁荣。“往年回鹘（维吾尔族）入朝，大驱名马市茶而归。”——《封氏闻见记》": "【茶马贸易】茶开始作为商品，与游牧民族交换马匹，边境贸易逐渐繁荣。“往年回鹘（维吾尔族）入朝，大驱名马市茶而归。”——《封氏闻见记》",
    "煮茶法": "煮茶法",
    "唐朝以蒸青茶饼为主，而饮茶的方式也发展到了煎茶，也称煮茶法。陆羽在《茶经》详尽阐述了主流的煎茶方法为：炙茶、贮茶、碾茶、罗茶、择水、烹水煎茶、分茶至各茶碗，使沫饽均分。": "唐朝以蒸青茶饼为主，而饮茶的方式也发展到了煎茶，也称煮茶法。陆羽在《茶经》详尽阐述了主流的煎茶方法为：炙茶、贮茶、碾茶、罗茶、择水、烹水煎茶、分茶至各茶碗，使沫饽均分。",
    "茶圣": "茶圣",
    "【茶圣】世界第一部茶叶专著《茶经》问世，陆羽被后人奉为“茶圣”": "【茶圣】世界第一部茶叶专著《茶经》问世，陆羽被后人奉为“茶圣”",
    "茶初入日本": "茶初入日本",
    "【茶初入日本】随着佛教的传播，日僧最澄大师自中国带茶籽回日本": "【茶初入日本】随着佛教的传播，日僧最澄大师自中国带茶籽回日本",
    "盛于宋": "盛于宋",
    "【盛于宋】南宋临安（今杭州）茶肆林立，乡镇茶馆繁盛，茶文化在宋代十分繁盛": "【盛于宋】南宋临安（今杭州）茶肆林立，乡镇茶馆繁盛，茶文化在宋代十分繁盛",
    "斗茶": "斗茶",
    "【斗茶】也称点茶，是宋朝四大雅事，可见其风靡程度，后日本的抹茶技艺也源自于此。": "【斗茶】也称点茶，是宋朝四大雅事，可见其风靡程度，后日本的抹茶技艺也源自于此。",
    "点茶法": "点茶法",
    "点茶法。点茶法是在煎茶法的基础上发展起来，步骤更加精细。先要将饼茶碾成末、茶罗过筛。备好沸水器具，将茶末调成膏状，点入沸水。同时进行「击拂」，形成泡沫状茶汤，同时也可以进行「斗茶]": "点茶法。点茶法是在煎茶法的基础上发展起来，步骤更加精细。先要将饼茶碾成末、茶罗过筛。备好沸水器具，将茶末调成膏状，点入沸水。同时进行「击拂」，形成泡沫状茶汤，同时也可以进行「斗茶]",
    "茶马互市": "茶马互市",
    "【茶马互市】北方游牧民族“七日可无米，一日不可无茶”用马换茶，逐渐形成贸易。": "【茶马互市】北方游牧民族“七日可无米，一日不可无茶”用马换茶，逐渐形成贸易。",
    "大观茶论": "大观茶论",
    "【大观茶论】宋徽宗赵佶著《大观茶论》一书，上起皇帝，下至士大夫，无不好茶": "【大观茶论】宋徽宗赵佶著《大观茶论》一书，上起皇帝，下至士大夫，无不好茶",
    "茶再入日本": "茶再入日本",
    "【茶再入日本】明港荣和尚 来中国学习禅宗，同时将宋代点茶技艺带回日本，保留至今，成为抹茶，抹茶开始在日本发展": "【茶再入日本】明港荣和尚 来中国学习禅宗，同时将宋代点茶技艺带回日本，保留至今，成为抹茶，抹茶开始在日本发展",
    "蓬勃发展": "蓬勃发展",
    "【蓬勃发展】元代茶文化继承于宋朝，在民间蓬勃发展并有多种吃法": "【蓬勃发展】元代茶文化继承于宋朝，在民间蓬勃发展并有多种吃法",
    "瀹茶法": "瀹茶法",
    "【瀹茶法】明太祖朱元璋将明以前的团饼茶改为散茶后，茶的品饮在民间得到发展，民间将散茶放入茶盏或茶壶中直接用沸水冲泡。此法叫淪茶法，也称泡茶法。比之煎茶、点茶更加便利。": "【瀹茶法】明太祖朱元璋将明以前的团饼茶改为散茶后，茶的品饮在民间得到发展，民间将散茶放入茶盏或茶壶中直接用沸水冲泡。此法叫淪茶法，也称泡茶法。比之煎茶、点茶更加便利。",
    "废团改散": "废团改散",
    "【废团改散】明太祖朱元璋将以前的团茶改为芽茶(散茶），促进了茶叶平民化": "【废团改散】明太祖朱元璋将以前的团茶改为芽茶(散茶），促进了茶叶平民化",
    "都给朕喝散茶": "都给朕喝散茶",
    "【都给朕喝散茶】朱元璋将团茶改为散茶，茶叶开始平民化，这期间都是绿茶，还没有红茶的出现。": "【都给朕喝散茶】朱元璋将团茶改为散茶，茶叶开始平民化，这期间都是绿茶，还没有红茶的出现。",
    "红茶意外出世": "红茶意外出世",
    "【明朝中后期，糟糕，不能要了的绿茶】一支北方军队路过桐木关，占驻茶厂，进)的茶青，无法及时烘干，积压发酵发生变色。【也许，还能挽救一下?】厂主心急如焚，赶紧用当地取暖用的马尾松进行烘干，并用松香味掩盖那特殊的“环味”。【死马当活马医吧】之后运往福州，这种产品国人是不会要了，那就托人卖到国外吧。【意外的“回购”】谁知到了第二年，竟然有人找上门来，专门订购那种带有松香味的茶叶。": "【明朝中后期，糟糕，不能要了的绿茶】一支北方军队路过桐木关，占驻茶厂，进)的茶青，无法及时烘干，积压发酵发生变色。【也许，还能挽救一下?】厂主心急如焚，赶紧用当地取暖用的马尾松进行烘干，并用松香味掩盖那特殊的“环味”。【死马当活马医吧】之后运往福州，这种产品国人是不会要了，那就托人卖到国外吧。【意外的“回购”】谁知到了第二年，竟然有人找上门来，专门订购那种带有松香味的茶叶。",
    "东西方的相遇": "东西方的相遇",
    "【东西方的相遇】传教士范礼安到达日本并记录了日本的饮茶习惯，这是西方对茶的初始印象": "【东西方的相遇】传教士范礼安到达日本并记录了日本的饮茶习惯，这是西方对茶的初始印象",
    "丝绸之路": "丝绸之路",
    "【丝绸之路】中国茶随着古代丝绸之路传入威尼斯、波斯以及俄国，但还未被西方接受": "【丝绸之路】中国茶随着古代丝绸之路传入威尼斯、波斯以及俄国，但还未被西方接受",
    "葡萄牙人与荷兰殖民者": "葡萄牙人与荷兰殖民者",
    "葡萄牙人在欧洲第一个喝上中国茶叶，荷兰殖民者将茶叶推广至整个欧洲。": "葡萄牙人在欧洲第一个喝上中国茶叶，荷兰殖民者将茶叶推广至整个欧洲。",
    "东印度公司记载，茶进入欧洲。": "东印度公司记载，茶进入欧洲。",
    "根据《东印度公司对华贸易编年史》记载自公元（1606年）茶伴随丝绸、锦缎和香料等贸易进入欧洲。": "根据《东印度公司对华贸易编年史》记载自公元（1606年）茶伴随丝绸、锦缎和香料等贸易进入欧洲。",
    "传入欧洲": "传入欧洲",
    "【传入欧洲】荷兰人自澳门贩茶，并转运入欧，后来的欧洲红茶据考证即为武夷出建山小种": "【传入欧洲】荷兰人自澳门贩茶，并转运入欧，后来的欧洲红茶据考证即为武夷出建山小种",
    "中国茶的西方之旅": "中国茶的西方之旅",
    "【中国茶的西方之旅】明朝嘉靖帝将澳门租借给葡萄牙，开始了东西方的贸易，茶由荷兰船只带入荷兰": "【中国茶的西方之旅】明朝嘉靖帝将澳门租借给葡萄牙，开始了东西方的贸易，茶由荷兰船只带入荷兰",
    "BOHEA TEA(武夷茶)": "BOHEA TEA(武夷茶)",
    "【BOHEA TEA(武夷茶)】明末崇祯十三年（1640年），红茶（有工夫茶、武夷茶、小种茶、白毫等）始由荷兰转至英国。-《清代通史》": "【BOHEA TEA(武夷茶)】明末崇祯十三年（1640年），红茶（有工夫茶、武夷茶、小种茶、白毫等）始由荷兰转至英国。-《清代通史》",
    "由盛转衰": "由盛转衰",
    "【由盛转衰】这一时期，茶的技术以继承为主，没有得到大的发展，是由盛转衰的一个时期。": "【由盛转衰】这一时期，茶的技术以继承为主，没有得到大的发展，是由盛转衰的一个时期。",
    "功夫茶": "功夫茶",
    "【功夫茶】随着清代时期六大茶类逐级出现，清代饮茶和鉴赏技术日益精湛，泡茶方法呈现百花齐放的景象。其中最具特色的饮用技艺首推“工夫茶泡法”。": "【功夫茶】随着清代时期六大茶类逐级出现，清代饮茶和鉴赏技术日益精湛，泡茶方法呈现百花齐放的景象。其中最具特色的饮用技艺首推“工夫茶泡法”。",
    "伦敦第一家咖啡馆": "伦敦第一家咖啡馆",
    "伦敦开设第一家咖啡馆，之后遍布伦敦和其他城市。起初咖啡馆只卖咖啡，后来增加了巧克力和茶饮料。": "伦敦开设第一家咖啡馆，之后遍布伦敦和其他城市。起初咖啡馆只卖咖啡，后来增加了巧克力和茶饮料。",
    "远销海外": "远销海外",
    "【远销海外】1657年，在法国市场销售，1669，英属印度公司从万丹运茶入英，1690年，中国茶获美国波士顿出售的特许执照": "【远销海外】1657年，在法国市场销售，1669，英属印度公司从万丹运茶入英，1690年，中国茶获美国波士顿出售的特许执照",
    "首次抵达英国": "首次抵达英国",
    "茶叶首次抵达英国，最早在咖啡馆进行销售和消费。茶被当作一种“热啤酒”，事先泡好后放在木桶里，有顾客需要时，从桶里舀出来": "茶叶首次抵达英国，最早在咖啡馆进行销售和消费。茶被当作一种“热啤酒”，事先泡好后放在木桶里，有顾客需要时，从桶里舀出来",
    "茶的英国有明确日期的最早记载": "茶的英国有明确日期的最早记载",
    "伦敦《政治快报》（Mercurius Politicus）刊出一则茶广告，应该是茶在英国有明确日期的最早记载。": "伦敦《政治快报》（Mercurius Politicus）刊出一则茶广告，应该是茶在英国有明确日期的最早记载。",
    "茶叶关税定为119%": "茶叶关税定为119%",
    "随着茶越来越受欢迎，经济头脑发达的查理二世将茶叶关税定为119%，但这一价格实在太高，使得英国茶叶走私泛滥": "随着茶越来越受欢迎，经济头脑发达的查理二世将茶叶关税定为119%，但这一价格实在太高，使得英国茶叶走私泛滥",
    "英国跌宕起伏的茶的消费史": "英国跌宕起伏的茶的消费史",
    "茶叶进入英国后，演绎了一部跌宕起伏的茶的消费史，丰富多彩的茶的社会文化史。作为一种典型的“中国造”全球化商品，茶深深改变了英国人的饮食文化、消费习惯和生活方式。": "茶叶进入英国后，演绎了一部跌宕起伏的茶的消费史，丰富多彩的茶的社会文化史。作为一种典型的“中国造”全球化商品，茶深深改变了英国人的饮食文化、消费习惯和生活方式。",
    "《消费税条例》": "《消费税条例》",
    "英国政府发布《消费税条例》规定，对咖啡征收消费税，每加仑4便士，而茶叶和巧克力消费税则高达8便士": "英国政府发布《消费税条例》规定，对咖啡征收消费税，每加仑4便士，而茶叶和巧克力消费税则高达8便士",
    "一箱价值不菲的红茶": "一箱价值不菲的红茶",
    "葡萄牙凯瑟琳公主带着丰厚的嫁妆嫁给了英王查理二世，包括战略价值重大的孟买港，据说还有一箱价值不菲的红茶——凯瑟琳也因此被誉为“饮茶皇后”。": "葡萄牙凯瑟琳公主带着丰厚的嫁妆嫁给了英王查理二世，包括战略价值重大的孟买港，据说还有一箱价值不菲的红茶——凯瑟琳也因此被誉为“饮茶皇后”。",
    "海外进口茶叶最早记载": "海外进口茶叶最早记载",
    "东印度公司海外进口茶叶最早记载，公司董事部用4镑5先令购买了2磅2盎司茶叶，作为礼物献给英王查理二世。": "东印度公司海外进口茶叶最早记载，公司董事部用4镑5先令购买了2磅2盎司茶叶，作为礼物献给英王查理二世。",
    "第一宗海外进口茶叶商业订单": "第一宗海外进口茶叶商业订单",
    "东印度公司进口茶叶143磅，成为公司第一宗海外进口茶叶商业订单。": "东印度公司进口茶叶143磅，成为公司第一宗海外进口茶叶商业订单。",
    "贵族社交的重要组成部分": "贵族社交的重要组成部分",
    "17世纪80年代后，饮茶甚至已经成为英国上流社会和贵族社交、家庭生活的重要组成部分。": "17世纪80年代后，饮茶甚至已经成为英国上流社会和贵族社交、家庭生活的重要组成部分。",
    "投资和货物清单": "投资和货物清单",
    "茶叶被东印度公司首次列入驶往中国商船的“投资和货物清单”。": "茶叶被东印度公司首次列入驶往中国商船的“投资和货物清单”。",
    "“多罗西号”（Dorothy）商船的新指令": "“多罗西号”（Dorothy）商船的新指令",
    "“多罗西号”（Dorothy）商船接到指令，被要求进口纺织品、中国瓷器、漆器以及鸟类，除此之外，他们还被要求带回一种新的商品：大量桶装上乘好茶。": "“多罗西号”（Dorothy）商船接到指令，被要求进口纺织品、中国瓷器、漆器以及鸟类，除此之外，他们还被要求带回一种新的商品：大量桶装上乘好茶。",
    "贸易垄断权": "贸易垄断权",
    "东印度公司获得进口中国茶叶的贸易垄断权": "东印度公司获得进口中国茶叶的贸易垄断权",
    "直接贸易的权利": "直接贸易的权利",
    "东印度获得直接与中国广州进行贸易的权利。": "东印度获得直接与中国广州进行贸易的权利。",
    "《续茶经》始见小种": "《续茶经》始见小种",
    "【《续茶经》始见小种】武夷茶在山上者为岩茶，水边者为洲茶…..其最佳者名日工夫茶，工夫之上又有小种。": "【《续茶经》始见小种】武夷茶在山上者为岩茶，水边者为洲茶…..其最佳者名日工夫茶，工夫之上又有小种。",
    "万里茶道从这里开始": "万里茶道从这里开始",
    "【万里茶道从这里开始】中俄签订《哈克图条约》，武夷茶开始源源不断的通过陆路由崇安县运往俄罗斯圣彼得堡。": "【万里茶道从这里开始】中俄签订《哈克图条约》，武夷茶开始源源不断的通过陆路由崇安县运往俄罗斯圣彼得堡。",
    "来喝下午茶吧": "来喝下午茶吧",
    "【来喝下午茶吧】自凯瑟琳公主嫁往英国，茶逐渐在英国贵妇阶层中形成以红茶为主的饮下午茶风气": "【来喝下午茶吧】自凯瑟琳公主嫁往英国，茶逐渐在英国贵妇阶层中形成以红茶为主的饮下午茶风气",
    "茶在国外的广泛推广": "茶在国外的广泛推广",
    "零售店店主家庭的预算中，每周要花3先令给全家人买面包，花4先令买茶叶和糖。正如一位评论家1757年所言，无论男女老少，身体健壮的还是文弱的，富有的还是穷人、乞丐，当他们口渴的时候会喝这种饮料，不渴的时候还会喝这种饮料。": "零售店店主家庭的预算中，每周要花3先令给全家人买面包，花4先令买茶叶和糖。正如一位评论家1757年所言，无论男女老少，身体健壮的还是文弱的，富有的还是穷人、乞丐，当他们口渴的时候会喝这种饮料，不渴的时候还会喝这种饮料。",
    "零售茶叶业务的扩展": "零售茶叶业务的扩展",
    "到18世纪下半叶，零售茶叶的业务逐渐从药店转到食品杂货店，反映了茶从药品到饮料的角色转变，真正成为广大社会下层平民的日常饮料。": "到18世纪下半叶，零售茶叶的业务逐渐从药店转到食品杂货店，反映了茶从药品到饮料的角色转变，真正成为广大社会下层平民的日常饮料。",
    "饮茶有害论": "饮茶有害论",
    "饮茶有害论。早在1722年，当时饮茶还不太普遍的时候，有人就通过给动物喝茶的方法来测试茶叶的副作用。": "饮茶有害论。早在1722年，当时饮茶还不太普遍的时候，有人就通过给动物喝茶的方法来测试茶叶的副作用。",
    "波士顿倾茶事件": "波士顿倾茶事件",
    "波士顿倾茶事件，由殖民地的民间反抗组织“自由之子”领导并行动，反对英国政府在殖民地征税并借此控制殖民地政府，以及反对英国东印度公司利用法案垄断北美的茶叶进口贸易，最终导致1775年美国革命战争爆发。": "波士顿倾茶事件，由殖民地的民间反抗组织“自由之子”领导并行动，反对英国政府在殖民地征税并借此控制殖民地政府，以及反对英国东印度公司利用法案垄断北美的茶叶进口贸易，最终导致1775年美国革命战争爆发。",
    "茶进入美国": "茶进入美国",
    "随着英国人移民北美，茶因此进入美国，并在公元（1775年）见证了因「茶叶条款」引发的美国独立战争事件。": "随着英国人移民北美，茶因此进入美国，并在公元（1775年）见证了因「茶叶条款」引发的美国独立战争事件。",
    "《抵代税法》": "《抵代税法》",
    "茶叶《抵代税法》（Commuta⁃tionAct）通过，茶叶关税率由之前的119%，下降到12.5%。茶叶关税的大幅降低，从长远看符合政府的财政利益，政府每年从关税和消费税中至少获利数十万镑。": "茶叶《抵代税法》（Commuta⁃tionAct）通过，茶叶关税率由之前的119%，下降到12.5%。茶叶关税的大幅降低，从长远看符合政府的财政利益，政府每年从关税和消费税中至少获利数十万镑。",
    "饮茶习俗已经随处可见": "饮茶习俗已经随处可见",
    "英国从宫殿到茅舍，饮茶习俗已经随处可见，反映了茶已经成为廉价大众消费饮品。": "英国从宫殿到茅舍，饮茶习俗已经随处可见，反映了茶已经成为廉价大众消费饮品。",
    "前所未有的繁荣": "前所未有的繁荣",
    "【前所未有的繁荣】武夷茶出口量较前50年有明显增长，1792年达到1835万公斤，是上世纪末平均出口量的815倍": "【前所未有的繁荣】武夷茶出口量较前50年有明显增长，1792年达到1835万公斤，是上世纪末平均出口量的815倍",
    "印度阿萨姆茶叶产地。": "印度阿萨姆茶叶产地。",
    "因鸦片引发中国与英国之间的贸易危机迫使英国考虑在印度阿萨姆地区另外开辟茶叶产地。": "因鸦片引发中国与英国之间的贸易危机迫使英国考虑在印度阿萨姆地区另外开辟茶叶产地。",
    "印度野生种茶树": "印度野生种茶树",
    "英国人在阿萨姆发现了印度野生种茶树并开始扦插培育": "英国人在阿萨姆发现了印度野生种茶树并开始扦插培育",
    "茶叶消费税占比": "茶叶消费税占比",
    "茶叶消费税占英国国内各项消费税的三分之二。": "茶叶消费税占英国国内各项消费税的三分之二。",
    "印度第一批茶叶运抵伦敦": "印度第一批茶叶运抵伦敦",
    "印度第一批茶叶运抵伦敦，并成为了迄今为止欧洲另一茶叶主要来源地之一。": "印度第一批茶叶运抵伦敦，并成为了迄今为止欧洲另一茶叶主要来源地之一。",
    "种植红茶": "种植红茶",
    "英国人开始在斯里兰卡锡兰尝试种植红茶": "英国人开始在斯里兰卡锡兰尝试种植红茶",
    "用鸦片换茶叶": "用鸦片换茶叶",
    "【用鸦片换茶叶】英国等欧洲国家发动鸦片战争，签订《南京条约》，五道口通商，进一步促进茶叶流通。": "【用鸦片换茶叶】英国等欧洲国家发动鸦片战争，签订《南京条约》，五道口通商，进一步促进茶叶流通。",
    "下午茶": "下午茶",
    "由贝德福德公爵夫人安娜·玛丽亚（AnnaMaria）引入的下午茶开始在贵族社交圈中风行，意味着红茶中加糖加奶、再配以糕点的饮茶方式成为新的时代风尚。": "由贝德福德公爵夫人安娜·玛丽亚（AnnaMaria）引入的下午茶开始在贵族社交圈中风行，意味着红茶中加糖加奶、再配以糕点的饮茶方式成为新的时代风尚。",
    "植物学家": "植物学家",
    "【植物学家】受英国政府委托，植物学家罗伯特·福琼多次乔装进入武夷山茶区，学习中国茶技艺。": "【植物学家】受英国政府委托，植物学家罗伯特·福琼多次乔装进入武夷山茶区，学习中国茶技艺。",
    "建立茶园": "建立茶园",
    "英国人用中国茶种在大吉岭种植茶叶，随后逐渐建立了大量在阿萨姆和大吉岭的茶园。": "英国人用中国茶种在大吉岭种植茶叶，随后逐渐建立了大量在阿萨姆和大吉岭的茶园。",
    "急需正名，正山与外山": "急需正名，正山与外山",
    "【急需正名，正山与外山】武夷茶的火爆造成了福建其他地区的效仿，为区别桐木村和周边地区的茶，就有了“正山”和“外山”的概念": "【急需正名，正山与外山】武夷茶的火爆造成了福建其他地区的效仿，为区别桐木村和周边地区的茶，就有了“正山”和“外山”的概念",
    "茶叶大盗": "茶叶大盗",
    "【茶叶大盗】第二次来到中国的福琼将武夷山茶树和工人骗到了印度大吉岭": "【茶叶大盗】第二次来到中国的福琼将武夷山茶树和工人骗到了印度大吉岭",
    "中国茶依然占领市场": "中国茶依然占领市场",
    "中国茶依然占领市场。这个时候，虽然有印度红茶开始销售，可市场比例只有4%": "中国茶依然占领市场。这个时候，虽然有印度红茶开始销售，可市场比例只有4%",
    "锡兰红茶开始量产": "锡兰红茶开始量产",
    "锡兰红茶开始量产，苏伊士运河开通，蒸汽机被应用到茶叶生产中，大大降低了生产成本，茶叶价格被再次降低，在英国成为人人都喝得起的大众饮品。": "锡兰红茶开始量产，苏伊士运河开通，蒸汽机被应用到茶叶生产中，大大降低了生产成本，茶叶价格被再次降低，在英国成为人人都喝得起的大众饮品。",
    "新的工艺出现": "新的工艺出现",
    "【新的工艺出现】第一台切茶机出现，红碎茶更得到了欧洲市": "【新的工艺出现】第一台切茶机出现，红碎茶更得到了欧洲市",
    "衰落调零时期的开始": "衰落调零时期的开始",
    "中国茶叶生产的衰落凋零时期的开始，因受到政治、经济方面影响、国际茶叶市场竞争失利，国内茶叶生产近乎停滞。": "中国茶叶生产的衰落凋零时期的开始，因受到政治、经济方面影响、国际茶叶市场竞争失利，国内茶叶生产近乎停滞。",
    "立顿茶的印刷广告": "立顿茶的印刷广告",
    "立顿茶一则刊登在1896年12月18日《图形报》上的印刷广告。报纸上的广告推销这种茶叶来自阳光沐浴下的锡兰，茶叶价格从每磅1先令到1先令7便士不等。": "立顿茶一则刊登在1896年12月18日《图形报》上的印刷广告。报纸上的广告推销这种茶叶来自阳光沐浴下的锡兰，茶叶价格从每磅1先令到1先令7便士不等。",
    "印度也可以产红茶啦": "印度也可以产红茶啦",
    "【印度也可以产红茶啦】中国茶叶及制茶技术成功移植至印度，印度茶叶生产兴旺发达并最终扩及全球": "【印度也可以产红茶啦】中国茶叶及制茶技术成功移植至印度，印度茶叶生产兴旺发达并最终扩及全球",
    "突然急转直下的下滑": "突然急转直下的下滑",
    "突然急转直下的下滑。更方便的工艺，更便宜的价格，更大的产量，印度红茶在市场的比例上升到59%。": "突然急转直下的下滑。更方便的工艺，更便宜的价格，更大的产量，印度红茶在市场的比例上升到59%。",
    "步履维艰": "步履维艰",
    "【步履维艰】这一时期，战事不断，茶发展举步维艰1915年万国博览会，安徽“太平猴魁”江西“婺绿”浙江“惠明茶”获金奖。茶文化风靡全球": "【步履维艰】这一时期，战事不断，茶发展举步维艰1915年万国博览会，安徽“太平猴魁”江西“婺绿”浙江“惠明茶”获金奖。茶文化风靡全球",
    "喝茶方式逐步简化": "喝茶方式逐步简化",
    "自清代六大茶类出现后，喝茶方式逐步简化。碗泡法直接冲泡茶叶 是现在主流的泡饮习惯": "自清代六大茶类出现后，喝茶方式逐步简化。碗泡法直接冲泡茶叶 是现在主流的泡饮习惯",
    "学习外国茶业先进技术": "学习外国茶业先进技术",
    "派遣有志知识青年，出国留学深造，学习外国茶业先进技术。云南派朱文精去日本静冈学习种茶、制茶。": "派遣有志知识青年，出国留学深造，学习外国茶业先进技术。云南派朱文精去日本静冈学习种茶、制茶。",
    "国内开始效仿国外": "国内开始效仿国外",
    "国内开始效仿国外，建立茶叶试验（实验）场，设置茶叶科研机构。北洋政府农商部湖北羊楼洞茶业示范场改名茶业试验场，建有试验茶园和实验茶厂。": "国内开始效仿国外，建立茶叶试验（实验）场，设置茶叶科研机构。北洋政府农商部湖北羊楼洞茶业示范场改名茶业试验场，建有试验茶园和实验茶厂。",
    "赴日本学习茶技": "赴日本学习茶技",
    "浙江选派吴觉农和葛敬应赴日本学习茶技": "浙江选派吴觉农和葛敬应赴日本学习茶技",
    "去日本学习园艺": "去日本学习园艺",
    "蒋芸生去日本学习园艺": "蒋芸生去日本学习园艺",
    "茶叶高等教育": "茶叶高等教育",
    "广州中山大学农学院成立茶蔗部设茶作、蔗作两专科，学制2年，后改设4年本科，为茶叶高等教育开了先河": "广州中山大学农学院成立茶蔗部设茶作、蔗作两专科，学制2年，后改设4年本科，为茶叶高等教育开了先河",
    "六堡产茶盛况": "六堡产茶盛况",
    "六堡产茶盛况。《广西特产志略》载：“在苍梧之最大出品，且为特产者，首推六堡茶，就其六堡一区而言（五堡，四堡）俱有出茶，但不及六堡之多，每年出口者，产额在60万斤以上，在1926～1927年，每担估价三十元左右。”": "六堡产茶盛况。《广西特产志略》载：“在苍梧之最大出品，且为特产者，首推六堡茶，就其六堡一区而言（五堡，四堡）俱有出茶，但不及六堡之多，每年出口者，产额在60万斤以上，在1926～1927年，每担估价三十元左右。”",
    "实验茶场": "实验茶场",
    "农业部中央农业实验所湄潭实验茶场正式成立": "农业部中央农业实验所湄潭实验茶场正式成立",
    "东南茶叶改良总场": "东南茶叶改良总场",
    "财政部贸易委员会在浙江衢县成立了东南茶叶改良总场": "财政部贸易委员会在浙江衢县成立了东南茶叶改良总场",
    "全国茶叶专业会议": "全国茶叶专业会议",
    "1954年，召开全国茶叶专业会议，确定“大力发展茶叶生产”方针": "1954年，召开全国茶叶专业会议，确定“大力发展茶叶生产”方针",
    "百废待兴": "百废待兴",
    "【百废待兴】1949年12月，中国茶叶公司成立，属贸易部、农业部双重领导；": "【百废待兴】1949年12月，中国茶叶公司成立，属贸易部、农业部双重领导；",
    "双重打击": "双重打击",
    "双重打击。国内时局的动荡，市场的不景气，武夷红茶陷入困境，茶农不得不转种毛竹等来营生。": "双重打击。国内时局的动荡，市场的不景气，武夷红茶陷入困境，茶农不得不转种毛竹等来营生。",
    "百废待兴，茶业重振": "百废待兴，茶业重振",
    "【百废待兴，茶业重振】在林馥生、张天福、吴觉农及当地茶农等茶业人的默默耕耘与奉献下，武夷红茶逐步重振。": "【百废待兴，茶业重振】在林馥生、张天福、吴觉农及当地茶农等茶业人的默默耕耘与奉献下，武夷红茶逐步重振。",
    "中国农业科学院茶叶研究所": "中国农业科学院茶叶研究所",
    "中国农业科学院茶叶研究所在浙江杭州成立，标志着中国茶叶研究进入到了有计划、有组织发展阶段": "中国农业科学院茶叶研究所在浙江杭州成立，标志着中国茶叶研究进入到了有计划、有组织发展阶段",
    "南茶北引": "南茶北引",
    "1962年，山东开展“南茶北引”试验": "1962年，山东开展“南茶北引”试验",
    "云南特大野生大茶树": "云南特大野生大茶树",
    "于云南勐海县发现特大野生大茶树，树龄1700年": "于云南勐海县发现特大野生大茶树，树龄1700年",
    "恢复发展时期的开始": "恢复发展时期的开始",
    "是中国茶叶生产的恢复发展时期的开始，大量旧茶园得以恢复种植生产，同时建立新茶园，改进新品种，推行科学种茶，致使茶叶经济稳定发展。": "是中国茶叶生产的恢复发展时期的开始，大量旧茶园得以恢复种植生产，同时建立新茶园，改进新品种，推行科学种茶，致使茶叶经济稳定发展。",
    "茶人之家": "茶人之家",
    "第一个以弘扬茶文化为宗旨的杭州“茶人之家”成立": "第一个以弘扬茶文化为宗旨的杭州“茶人之家”成立",
    "新的饮茶方式": "新的饮茶方式",
    "当然也有添加其他调料进行饮用的多元化，有加糖、加冰、加奶、加酥油、加珍珠、加奶盖等。": "当然也有添加其他调料进行饮用的多元化，有加糖、加冰、加奶、加酥油、加珍珠、加奶盖等。",
    "中国茶叶经济的崭新发展": "中国茶叶经济的崭新发展",
    "伴随着在卡塔尔多哈举行的世界贸易组织「第四届」部长级会议通过了中国加入世贸组织的法律文件生效，中国茶叶经济也走入了一个崭新的发展阶段。": "伴随着在卡塔尔多哈举行的世界贸易组织「第四届」部长级会议通过了中国加入世贸组织的法律文件生效，中国茶叶经济也走入了一个崭新的发展阶段。",
    "金骏眉问世": "金骏眉问世",
    "【金骏眉问世】茶人江元勋等人综合北京等地茶友的意见，邀请制茶师梁骏德，在正山小种传统工艺上进行改良，取单芽制作的高档红茶，取名金骏眉": "【金骏眉问世】茶人江元勋等人综合北京等地茶友的意见，邀请制茶师梁骏德，在正山小种传统工艺上进行改良，取单芽制作的高档红茶，取名金骏眉",
    "第一个茶文化学院": "第一个茶文化学院",
    "浙江农林大学在全国建立了第一个茶文化学院，同年开始招生，进行本科学历的茶文化教育": "浙江农林大学在全国建立了第一个茶文化学院，同年开始招生，进行本科学历的茶文化教育",
    "爆火后的纷争": "爆火后的纷争",
    "爆火后的纷争。“金骏眉”的爆火，引来了这究竟是某企业的商标还是茶名的纷争，最终在2013年判决为茶叶通用名称。": "爆火后的纷争。“金骏眉”的爆火，引来了这究竟是某企业的商标还是茶名的纷争，最终在2013年判决为茶叶通用名称。",
    "中国茶叶经济的高光": "中国茶叶经济的高光",
    "伴随着中国政府扩大内需促进经济增长的「四万亿投资」政策落地实施，中国茶叶经济凭借这股强劲的东风在国际市场的舞台上又一次迎来了其历史高光时刻，并在新一代「年轻茶人」的不断创新下，以中国茶文化为核心的「概念商品」在一定程度上影响了世界潮流文化的走向。": "伴随着中国政府扩大内需促进经济增长的「四万亿投资」政策落地实施，中国茶叶经济凭借这股强劲的东风在国际市场的舞台上又一次迎来了其历史高光时刻，并在新一代「年轻茶人」的不断创新下，以中国茶文化为核心的「概念商品」在一定程度上影响了世界潮流文化的走向。",
    "渐成体系，稳健发展": "渐成体系，稳健发展",
    "渐成体系，稳健发展。国家标准：《红茶第3部分：小种红茶》GB/T13738.3-2012发布；地方标准：《地理标志产品武夷红茶》DB35/T1228-2015发布；行业标准：《金骏眉》GH/T 1118-2015发布；团体标准：《骏眉红茶》T/CMA 002-2018发布": "渐成体系，稳健发展。国家标准：《红茶第3部分：小种红茶》GB/T13738.3-2012发布；地方标准：《地理标志产品武夷红茶》DB35/T1228-2015发布；行业标准：《金骏眉》GH/T 1118-2015发布；团体标准：《骏眉红茶》T/CMA 002-2018发布",
    "风靡世界": "风靡世界",
    "【风靡世界】截止2017年底，中国茶区面积4588万亩，产量260.9万吨，出口35.5万吨，实现了茶业前所未有的巅峰。至此，中国茶风靡世界": "【风靡世界】截止2017年底，中国茶区面积4588万亩，产量260.9万吨，出口35.5万吨，实现了茶业前所未有的巅峰。至此，中国茶风靡世界",
    "国际茶日": "国际茶日",
    "第74届联合国大会宣布每年5月21日为“国际茶日”，以赞美茶叶对经济、社会和文化的价值，这是以中国为主的产茶国家首次成功推动设立的农业领域国际性节日。": "第74届联合国大会宣布每年5月21日为“国际茶日”，以赞美茶叶对经济、社会和文化的价值，这是以中国为主的产茶国家首次成功推动设立的农业领域国际性节日。",

"广东省近几年产量（吨）":"广东省近几年产量（吨）",
"安徽省近几年产量（吨）":"安徽省近几年产量（吨）",
"湖南省近几年产量（吨）":"湖南省近几年产量（吨）",
"浙江省近几年产量（吨）":"浙江省近几年产量（吨）",
"贵州省近几年产量（吨）":"贵州省近几年产量（吨）",
"云南省近几年产量（吨）":"云南省近几年产量（吨）",
"广西省近几年产量（吨）":"广西省近几年产量（吨）",
"江苏省近几年产量（吨）":"江苏省近几年产量（吨）",
"四川省近几年产量（吨）":"四川省近几年产量（吨）",
"福建省近几年产量（吨）":"福建省近几年产量（吨）",
"陕西省近几年产量（吨）":"陕西省近几年产量（吨）",
"湖北省近几年产量（吨）":"湖北省近几年产量（吨）",

"广东省近几年产值（亿元）":"广东省近几年产值（亿元）",
"安徽省近几年产值（亿元）":"安徽省近几年产值（亿元）",
"湖南省近几年产值（亿元）":"湖南省近几年产值（亿元）",
"浙江省近几年产值（亿元）":"浙江省近几年产值（亿元）",
"贵州省近几年产值（亿元）":"贵州省近几年产值（亿元）",
"云南省近几年产值（亿元）":"云南省近几年产值（亿元）",
"广西省近几年产值（亿元）":"广西省近几年产值（亿元）",
"江苏省近几年产值（亿元）":"江苏省近几年产值（亿元）",
"四川省近几年产值（亿元）":"四川省近几年产值（亿元）",
"福建省近几年产值（亿元）":"福建省近几年产值（亿元）",
"陕西省近几年产值（亿元）":"陕西省近几年产值（亿元）",
"湖北省近几年产值（亿元）":"湖北省近几年产值（亿元）",


"茶省产销气泡图":"茶省产销气泡图",
"茶品产销丝绸图":"茶品产销丝绸图",
"茶园面积图":"茶园面积图",
"产量(万吨)": "产量(万吨)",
"内销量(万吨)":"内销量(万吨)",
"内销额(亿元)":"内销额(亿元)",
"选择所有":"选择所有",
"丝绸图":"丝绸图",
"显示各类茶近五年数据的详细情况，颜色代表茶的类别":"显示各类茶近五年数据的详细情况，颜色代表茶的类别",
"选择图例":"选择图例",
"点击小圆圈，详细查看某种茶的数据":"点击小圆圈，详细查看某种茶的数据",
"点击此处，选择查看所有图例":"点击此处，选择查看所有图例",
"选项卡":"选项卡",
"可以选择要查看的数据类别":"可以选择要查看的数据类别",
"万吨":"万吨",
"亿元":"亿元",

/* 别删这一段！ 真有用*/
"Anhui":"皖",
"Hunan":"湘",
"Jiangsu":"苏",
"Zhejiang":"浙",
"Guizhou":"黔",
"Sichuan":"川",
"Yunnan":"滇",
"Guangxi":"桂",
"Fujian":"闽",
"Hubei":"鄂",
"Shaanxi":"陕",
"Jiangxi":"赣",
"Guangdong":"粤",

"2022年各茶采制时间表":"2022年各茶采制时间表",

}
